export default {
  '1-1': [['@', '1', '1', '3', '3', '6', '@'],
    ['5', '5', '1', '3', '3', '6', '@'],
    ['@', '5', '1', '1', '3', '6', '6'],
    ['5', '5', '2', '2', '2', '6', '4'],
    ['7', '7', '7', '7', '2', '2', '4'],
    ['8', '8', '8', '7', '4', '4', '4'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '1-10': [['@', '1', '1', '3', '3', '2', '@'],
    ['7', '7', '1', '3', '3', '2', '@'],
    ['7', '6', '1', '1', '3', '2', '2'],
    ['7', '6', '@', '4', '4', '4', '2'],
    ['7', '6', '6', '4', '8', '8', '8'],
    ['5', '6', '5', '4', '8', '8', '8'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '1-11': [['@', '1', '1', '8', '8', '8', '@'],
    ['7', '7', '1', '8', '8', '8', '@'],
    ['7', '6', '1', '1', '4', '4', '4'],
    ['7', '6', '6', '@', '4', '3', '3'],
    ['7', '6', '2', '2', '4', '3', '3'],
    ['5', '6', '5', '2', '2', '2', '3'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '1-12': [['@', '2', '3', '3', '1', '1', '@'],
    ['2', '2', '3', '3', '3', '1', '@'],
    ['2', '7', '7', '7', '7', '1', '1'],
    ['2', '7', '6', '5', '@', '5', '4'],
    ['8', '8', '6', '5', '5', '5', '4'],
    ['8', '8', '6', '6', '4', '4', '4'],
    ['8', '8', '6', '@', '@', '@', '@']],
  '1-13': [['@', '1', '1', '4', '4', '4', '@'],
    ['8', '8', '1', '5', '5', '4', '@'],
    ['8', '8', '1', '1', '5', '4', '7'],
    ['8', '8', '6', '5', '5', '@', '7'],
    ['6', '6', '6', '6', '2', '2', '7'],
    ['3', '3', '2', '2', '2', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '1-14': [['@', '2', '3', '3', '1', '1', '@'],
    ['2', '2', '3', '3', '3', '1', '@'],
    ['2', '6', '4', '4', '4', '1', '1'],
    ['2', '6', '4', '8', '8', '8', '@'],
    ['6', '6', '4', '8', '8', '8', '7'],
    ['5', '6', '5', '7', '7', '7', '7'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '1-15': [['@', '1', '1', '4', '4', '4', '@'],
    ['3', '3', '1', '5', '5', '4', '@'],
    ['3', '3', '1', '1', '5', '4', '6'],
    ['3', '2', '7', '5', '5', '6', '6'],
    ['@', '2', '7', '8', '8', '8', '6'],
    ['2', '2', '7', '8', '8', '8', '6'],
    ['2', '7', '7', '@', '@', '@', '@']],
  '1-16': [['@', '1', '1', '4', '4', '4', '@'],
    ['7', '7', '1', '5', '5', '4', '@'],
    ['7', '2', '1', '1', '5', '4', '6'],
    ['7', '2', '2', '5', '5', '6', '6'],
    ['7', '@', '2', '8', '8', '8', '6'],
    ['3', '3', '2', '8', '8', '8', '6'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '1-17': [['@', '1', '1', '3', '3', '2', '@'],
    ['7', '7', '1', '3', '3', '2', '@'],
    ['7', '6', '1', '1', '3', '2', '2'],
    ['7', '6', '6', '4', '4', '4', '2'],
    ['7', '6', '@', '4', '8', '8', '8'],
    ['5', '6', '5', '4', '8', '8', '8'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '1-18': [['@', '1', '1', '4', '4', '4', '@'],
    ['7', '2', '1', '5', '5', '4', '@'],
    ['7', '2', '1', '1', '5', '4', '3'],
    ['7', '2', '2', '5', '5', '3', '3'],
    ['7', '7', '2', '@', '6', '3', '3'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '1-19': [['@', '1', '1', '2', '7', '7', '@'],
    ['3', '3', '1', '2', '2', '7', '@'],
    ['3', '3', '1', '1', '2', '7', '6'],
    ['5', '3', '5', '4', '2', '7', '6'],
    ['5', '5', '5', '4', '@', '6', '6'],
    ['8', '8', '8', '4', '4', '4', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '1-2': [['@', '1', '1', '3', '3', '6', '@'],
    ['5', '5', '1', '3', '3', '6', '@'],
    ['5', '@', '1', '1', '3', '6', '6'],
    ['5', '5', '2', '2', '2', '6', '4'],
    ['7', '7', '7', '7', '2', '2', '4'],
    ['8', '8', '8', '7', '4', '4', '4'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '1-20': [['@', '1', '1', '4', '4', '4', '@'],
    ['3', '3', '1', '5', '5', '4', '@'],
    ['3', '3', '1', '1', '5', '4', '6'],
    ['3', '2', '2', '5', '5', '6', '6'],
    ['8', '8', '2', '2', '2', '@', '6'],
    ['8', '8', '7', '7', '7', '7', '6'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '1-21': [['@', '2', '3', '3', '5', '5', '@'],
    ['2', '2', '3', '3', '3', '5', '@'],
    ['2', '4', '4', '4', '5', '5', '1'],
    ['2', '7', '7', '4', '1', '1', '1'],
    ['8', '8', '7', '4', '1', '6', '@'],
    ['8', '8', '7', '6', '6', '6', '6'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '1-22': [['@', '1', '1', '4', '4', '4', '@'],
    ['8', '8', '1', '7', '7', '4', '@'],
    ['8', '8', '1', '1', '7', '4', '6'],
    ['8', '8', '2', '2', '7', '6', '6'],
    ['2', '2', '2', '5', '7', '5', '6'],
    ['@', '3', '3', '5', '5', '5', '6'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '1-23': [['@', '1', '1', '3', '3', '6', '@'],
    ['8', '8', '1', '3', '3', '6', '@'],
    ['8', '8', '1', '1', '3', '6', '6'],
    ['8', '8', '2', '2', '2', '6', '4'],
    ['7', '7', '7', '7', '2', '2', '4'],
    ['5', '@', '5', '7', '4', '4', '4'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '1-24': [['@', '1', '1', '4', '4', '4', '@'],
    ['8', '8', '1', '7', '7', '4', '@'],
    ['8', '8', '1', '1', '7', '4', '6'],
    ['8', '8', '2', '2', '7', '6', '6'],
    ['2', '2', '2', '5', '7', '5', '6'],
    ['3', '3', '@', '5', '5', '5', '6'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '1-25': [['@', '1', '1', '4', '4', '4', '@'],
    ['7', '2', '1', '5', '5', '4', '@'],
    ['7', '2', '1', '1', '5', '4', '6'],
    ['7', '2', '2', '5', '5', '6', '6'],
    ['7', '7', '2', '3', '3', '3', '6'],
    ['8', '8', '8', '@', '3', '3', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '1-26': [['@', '2', '3', '3', '1', '1', '@'],
    ['2', '2', '3', '3', '3', '1', '@'],
    ['2', '6', '6', '6', '6', '1', '1'],
    ['2', '7', '7', '6', '4', '4', '4'],
    ['8', '8', '7', '5', '5', '5', '4'],
    ['8', '8', '7', '5', '@', '5', '4'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '1-27': [['@', '1', '1', '4', '4', '4', '@'],
    ['8', '8', '1', '5', '5', '4', '@'],
    ['8', '8', '1', '1', '5', '4', '6'],
    ['8', '8', '7', '5', '5', '6', '6'],
    ['3', '3', '7', '7', '7', '7', '6'],
    ['3', '3', '2', '2', '2', '@', '6'],
    ['3', '2', '2', '@', '@', '@', '@']],
  '1-28': [['@', '1', '1', '3', '3', '6', '@'],
    ['7', '4', '1', '3', '3', '6', '@'],
    ['7', '4', '1', '1', '3', '6', '6'],
    ['7', '4', '4', '4', '5', '6', '5'],
    ['7', '7', '2', '2', '5', '5', '5'],
    ['8', '8', '8', '2', '2', '2', '@'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '1-29': [['@', '1', '1', '4', '4', '4', '@'],
    ['8', '8', '1', '7', '7', '4', '@'],
    ['8', '8', '1', '1', '7', '4', '6'],
    ['8', '8', '2', '2', '7', '6', '6'],
    ['2', '2', '2', '5', '7', '5', '6'],
    ['3', '3', '3', '5', '5', '5', '6'],
    ['@', '3', '3', '@', '@', '@', '@']],
  '1-3': [['@', '2', '3', '3', '1', '1', '@'],
    ['2', '2', '3', '3', '3', '1', '@'],
    ['2', '6', '@', '7', '7', '1', '1'],
    ['2', '6', '5', '5', '7', '8', '8'],
    ['4', '6', '6', '5', '7', '8', '8'],
    ['4', '6', '5', '5', '7', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '1-30': [['@', '1', '1', '3', '3', '6', '@'],
    ['8', '8', '1', '3', '3', '6', '@'],
    ['8', '8', '1', '1', '3', '6', '6'],
    ['8', '8', '2', '2', '2', '6', '4'],
    ['7', '7', '7', '7', '2', '2', '4'],
    ['5', '5', '5', '7', '4', '4', '4'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '1-31': [['@', '1', '1', '4', '4', '4', '@'],
    ['7', '7', '1', '5', '5', '4', '@'],
    ['7', '2', '1', '1', '5', '4', '6'],
    ['7', '2', '2', '5', '5', '6', '6'],
    ['7', '3', '2', '8', '8', '8', '6'],
    ['3', '3', '2', '8', '8', '8', '6'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '1-4': [['@', '2', '3', '3', '1', '1', '@'],
    ['2', '2', '3', '3', '3', '1', '@'],
    ['2', '7', '7', '@', '6', '1', '1'],
    ['2', '7', '8', '8', '6', '5', '5'],
    ['4', '7', '8', '8', '6', '6', '5'],
    ['4', '7', '8', '8', '6', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '1-5': [['@', '1', '1', '8', '8', '8', '@'],
    ['3', '3', '1', '8', '8', '8', '@'],
    ['3', '3', '1', '1', '@', '7', '7'],
    ['3', '2', '2', '4', '4', '4', '7'],
    ['5', '5', '2', '2', '2', '4', '7'],
    ['5', '6', '6', '6', '6', '4', '7'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '1-6': [['@', '1', '1', '5', '5', '5', '@'],
    ['7', '7', '1', '5', '4', '5', '@'],
    ['7', '2', '1', '1', '4', '@', '6'],
    ['7', '2', '4', '4', '4', '6', '6'],
    ['7', '2', '2', '8', '8', '8', '6'],
    ['3', '3', '2', '8', '8', '8', '6'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '1-7': [['@', '1', '1', '4', '4', '4', '@'],
    ['8', '8', '1', '5', '5', '4', '@'],
    ['8', '8', '1', '1', '5', '4', '@'],
    ['8', '8', '6', '5', '5', '2', '2'],
    ['3', '6', '6', '2', '2', '2', '7'],
    ['3', '3', '6', '7', '7', '7', '7'],
    ['3', '3', '6', '@', '@', '@', '@']],
  '1-8': [['@', '1', '1', '4', '4', '4', '@'],
    ['3', '3', '1', '7', '7', '4', '@'],
    ['3', '3', '1', '1', '7', '4', '6'],
    ['@', '3', '2', '2', '7', '6', '6'],
    ['2', '2', '2', '5', '7', '5', '6'],
    ['8', '8', '8', '5', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '1-9': [['@', '1', '1', '4', '4', '4', '@'],
    ['3', '3', '1', '7', '7', '4', '@'],
    ['3', '3', '1', '1', '7', '4', '6'],
    ['3', '@', '2', '2', '7', '6', '6'],
    ['2', '2', '2', '5', '7', '5', '6'],
    ['8', '8', '8', '5', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-1': [['2', '1', '1', '4', '4', '4', '@'],
    ['2', '2', '1', '@', '6', '4', '@'],
    ['@', '2', '1', '1', '6', '4', '3'],
    ['5', '2', '5', '6', '6', '3', '3'],
    ['5', '5', '5', '7', '6', '3', '3'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-10': [['1', '1', '5', '5', '5', '4', '@'],
    ['6', '1', '5', '@', '5', '4', '@'],
    ['6', '1', '1', '4', '4', '4', '7'],
    ['6', '6', '@', '7', '7', '7', '7'],
    ['6', '2', '2', '2', '3', '3', '3'],
    ['8', '8', '8', '2', '2', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-11': [['6', '6', '6', '6', '7', '7', '@'],
    ['2', '2', '6', '@', '7', '3', '@'],
    ['1', '2', '2', '2', '7', '3', '3'],
    ['1', '1', '1', '@', '7', '3', '3'],
    ['4', '5', '1', '5', '8', '8', '8'],
    ['4', '5', '5', '5', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '10-12': [['1', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '6'],
    ['2', '2', '7', '7', '@', '6', '6'],
    ['3', '2', '7', '8', '8', '8', '6'],
    ['3', '3', '7', '8', '8', '8', '6'],
    ['3', '3', '7', '@', '@', '@', '@']],
  '10-13': [['1', '1', '5', '5', '5', '4', '@'],
    ['6', '1', '5', '@', '5', '4', '@'],
    ['6', '1', '1', '4', '4', '4', '7'],
    ['6', '6', '2', '2', '2', '@', '7'],
    ['6', '2', '2', '3', '3', '3', '7'],
    ['8', '8', '8', '3', '3', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-14': [['2', '1', '1', '7', '7', '6', '@'],
    ['2', '2', '1', '@', '7', '6', '@'],
    ['4', '2', '1', '1', '7', '6', '6'],
    ['4', '2', '5', '5', '7', '6', '@'],
    ['4', '4', '4', '5', '8', '8', '8'],
    ['3', '3', '5', '5', '8', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '10-15': [['1', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '6'],
    ['2', '2', '7', '7', '7', '7', '6'],
    ['@', '2', '7', '3', '3', '6', '6'],
    ['8', '8', '8', '3', '3', '3', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-16': [['6', '6', '6', '6', '8', '8', '@'],
    ['1', '1', '6', '@', '8', '8', '@'],
    ['7', '1', '5', '5', '8', '8', '3'],
    ['7', '1', '1', '5', '4', '3', '3'],
    ['7', '@', '5', '5', '4', '3', '3'],
    ['7', '7', '2', '2', '4', '4', '4'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '10-17': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '@', '3', '3', '@'],
    ['4', '1', '1', '3', '3', '3', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['8', '8', '@', '2', '5', '6', '6'],
    ['8', '8', '2', '2', '5', '5', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '10-18': [['1', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '7'],
    ['2', '2', '6', '7', '7', '7', '7'],
    ['3', '2', '6', '@', '8', '8', '8'],
    ['3', '3', '6', '6', '8', '8', '8'],
    ['3', '3', '6', '@', '@', '@', '@']],
  '10-19': [['1', '1', '5', '5', '5', '4', '@'],
    ['6', '1', '5', '@', '5', '4', '@'],
    ['6', '1', '1', '4', '4', '4', '3'],
    ['6', '6', '2', '2', '2', '3', '3'],
    ['6', '2', '2', '7', '@', '3', '3'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-2': [['4', '4', '4', '5', '5', '2', '@'],
    ['7', '7', '4', '@', '5', '2', '@'],
    ['7', '@', '4', '5', '5', '2', '2'],
    ['7', '1', '6', '6', '6', '6', '2'],
    ['7', '1', '1', '1', '6', '3', '3'],
    ['8', '8', '8', '1', '3', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-20': [['1', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '6'],
    ['2', '2', '8', '8', '8', '6', '6'],
    ['3', '2', '8', '8', '8', '@', '6'],
    ['3', '3', '7', '7', '7', '7', '6'],
    ['3', '3', '7', '@', '@', '@', '@']],
  '10-21': [['4', '4', '4', '5', '5', '2', '@'],
    ['8', '8', '4', '@', '5', '2', '@'],
    ['8', '8', '4', '5', '5', '2', '2'],
    ['8', '8', '7', '7', '7', '7', '2'],
    ['3', '3', '1', '1', '6', '7', '@'],
    ['3', '3', '1', '6', '6', '6', '6'],
    ['3', '1', '1', '@', '@', '@', '@']],
  '10-22': [['3', '3', '5', '5', '1', '1', '@'],
    ['3', '3', '5', '@', '4', '1', '@'],
    ['7', '3', '5', '5', '4', '1', '1'],
    ['7', '7', '7', '7', '4', '4', '4'],
    ['6', '6', '6', '6', '8', '8', '8'],
    ['@', '6', '2', '2', '8', '8', '8'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '10-23': [['1', '1', '7', '7', '7', '7', '@'],
    ['2', '1', '7', '@', '3', '3', '@'],
    ['2', '1', '1', '3', '3', '3', '6'],
    ['2', '2', '8', '8', '5', '5', '6'],
    ['4', '2', '8', '8', '5', '6', '6'],
    ['4', '@', '8', '8', '5', '5', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '10-24': [['3', '3', '7', '7', '7', '7', '@'],
    ['3', '3', '7', '@', '1', '1', '@'],
    ['2', '3', '5', '5', '1', '8', '8'],
    ['2', '2', '5', '1', '1', '8', '8'],
    ['4', '2', '5', '5', '6', '8', '8'],
    ['4', '2', '@', '6', '6', '6', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '10-25': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '@', '3', '3', '@'],
    ['4', '1', '1', '2', '3', '3', '3'],
    ['4', '4', '4', '2', '2', '8', '8'],
    ['6', '6', '6', '6', '2', '8', '8'],
    ['5', '6', '5', '@', '2', '8', '8'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '10-26': [['1', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '7'],
    ['2', '2', '6', '8', '8', '8', '7'],
    ['3', '2', '6', '8', '8', '8', '7'],
    ['3', '3', '6', '6', '@', '7', '7'],
    ['3', '3', '6', '@', '@', '@', '@']],
  '10-27': [['6', '6', '6', '6', '1', '1', '@'],
    ['2', '2', '6', '@', '4', '1', '@'],
    ['7', '2', '2', '2', '4', '1', '1'],
    ['7', '7', '7', '7', '4', '4', '4'],
    ['8', '8', '3', '3', '5', '5', '5'],
    ['8', '8', '3', '3', '5', '@', '5'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '10-28': [['3', '3', '4', '4', '4', '6', '@'],
    ['3', '3', '2', '@', '4', '6', '@'],
    ['1', '3', '2', '2', '4', '6', '6'],
    ['1', '1', '1', '2', '5', '6', '5'],
    ['8', '8', '1', '2', '5', '5', '5'],
    ['8', '8', '7', '7', '7', '7', '@'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '10-29': [['3', '3', '7', '7', '1', '1', '@'],
    ['3', '3', '7', '@', '2', '1', '@'],
    ['6', '3', '7', '2', '2', '1', '1'],
    ['6', '6', '7', '2', '4', '8', '8'],
    ['6', '5', '5', '2', '4', '8', '8'],
    ['6', '5', '4', '4', '4', '8', '8'],
    ['@', '5', '5', '@', '@', '@', '@']],
  '10-3': [['3', '3', '5', '5', '5', '6', '@'],
    ['3', '3', '5', '@', '5', '6', '@'],
    ['7', '3', '@', '1', '1', '6', '6'],
    ['7', '8', '8', '8', '1', '6', '4'],
    ['7', '8', '8', '8', '1', '1', '4'],
    ['7', '7', '2', '2', '4', '4', '4'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '10-30': [['2', '1', '1', '3', '3', '3', '@'],
    ['2', '2', '1', '@', '3', '3', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['5', '5', '5', '8', '8', '8', '7'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '10-31': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '@', '3', '3', '@'],
    ['4', '1', '1', '2', '3', '3', '3'],
    ['4', '4', '4', '2', '5', '5', '5'],
    ['8', '8', '2', '2', '5', '6', '5'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '@', '@', '@', '@', '@']],
  '10-4': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '@', '3', '3', '@'],
    ['4', '1', '1', '@', '3', '3', '3'],
    ['4', '4', '4', '2', '5', '5', '5'],
    ['8', '8', '2', '2', '5', '6', '5'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '10-5': [['1', '1', '5', '5', '5', '6', '@'],
    ['4', '1', '5', '@', '5', '6', '@'],
    ['4', '1', '1', '2', '@', '6', '6'],
    ['4', '4', '4', '2', '2', '6', '3'],
    ['7', '7', '7', '7', '2', '3', '3'],
    ['8', '8', '8', '7', '2', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-6': [['6', '6', '6', '6', '3', '3', '@'],
    ['2', '2', '6', '@', '3', '3', '@'],
    ['1', '2', '2', '2', '3', '@', '7'],
    ['1', '1', '1', '7', '7', '7', '7'],
    ['4', '5', '1', '5', '8', '8', '8'],
    ['4', '5', '5', '5', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '10-7': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '@', '3', '3', '@'],
    ['4', '1', '1', '3', '3', '3', '@'],
    ['4', '4', '4', '2', '5', '5', '5'],
    ['8', '8', '2', '2', '5', '6', '5'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '10-8': [['3', '3', '7', '7', '7', '7', '@'],
    ['3', '3', '3', '@', '1', '7', '@'],
    ['5', '5', '1', '1', '1', '2', '2'],
    ['@', '5', '1', '2', '2', '2', '4'],
    ['5', '5', '6', '6', '6', '6', '4'],
    ['8', '8', '8', '6', '4', '4', '4'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '10-9': [['3', '3', '7', '7', '1', '1', '@'],
    ['3', '3', '7', '@', '2', '1', '@'],
    ['4', '3', '7', '2', '2', '1', '1'],
    ['4', '@', '7', '2', '5', '5', '5'],
    ['4', '4', '4', '2', '5', '6', '5'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-1': [['2', '1', '1', '5', '5', '5', '@'],
    ['2', '2', '1', '5', '@', '5', '@'],
    ['@', '2', '1', '1', '6', '7', '7'],
    ['3', '2', '6', '6', '6', '6', '7'],
    ['3', '3', '4', '8', '8', '8', '7'],
    ['3', '3', '4', '8', '8', '8', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '11-10': [['1', '1', '3', '3', '5', '5', '@'],
    ['2', '1', '3', '3', '@', '5', '@'],
    ['2', '1', '1', '3', '5', '5', '7'],
    ['2', '2', '@', '8', '8', '8', '7'],
    ['4', '2', '6', '8', '8', '8', '7'],
    ['4', '6', '6', '6', '6', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '11-11': [['1', '1', '3', '3', '5', '5', '@'],
    ['4', '1', '3', '3', '@', '5', '@'],
    ['4', '1', '1', '3', '5', '5', '6'],
    ['4', '4', '4', '@', '2', '2', '6'],
    ['8', '8', '2', '2', '2', '6', '6'],
    ['8', '8', '7', '7', '7', '7', '6'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '11-12': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '5', '@', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '3'],
    ['4', '4', '4', '2', '@', '3', '3'],
    ['8', '8', '2', '2', '6', '3', '3'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '11-13': [['1', '1', '3', '3', '5', '5', '@'],
    ['6', '1', '3', '3', '@', '5', '@'],
    ['6', '1', '1', '3', '5', '5', '4'],
    ['6', '6', '2', '2', '2', '@', '4'],
    ['6', '2', '2', '7', '4', '4', '4'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-14': [['1', '1', '7', '7', '7', '7', '@'],
    ['6', '1', '5', '5', '@', '7', '@'],
    ['6', '1', '1', '5', '4', '4', '4'],
    ['6', '6', '5', '5', '4', '3', '@'],
    ['6', '2', '2', '2', '4', '3', '3'],
    ['8', '8', '8', '2', '2', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-15': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '5', '@', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '3'],
    ['4', '4', '4', '2', '2', '3', '3'],
    ['@', '2', '2', '2', '6', '3', '3'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-16': [['1', '1', '7', '7', '7', '7', '@'],
    ['6', '1', '5', '5', '@', '7', '@'],
    ['6', '1', '1', '5', '4', '4', '4'],
    ['6', '6', '5', '5', '4', '3', '3'],
    ['6', '@', '2', '2', '4', '3', '3'],
    ['8', '8', '8', '2', '2', '2', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-17': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '5', '@', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '6'],
    ['4', '4', '4', '2', '3', '6', '6'],
    ['8', '8', '@', '2', '3', '3', '6'],
    ['8', '8', '2', '2', '3', '3', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '11-18': [['1', '1', '7', '7', '7', '7', '@'],
    ['6', '1', '5', '5', '@', '7', '@'],
    ['6', '1', '1', '5', '4', '4', '4'],
    ['6', '6', '5', '5', '4', '8', '8'],
    ['6', '2', '2', '@', '4', '8', '8'],
    ['3', '3', '2', '2', '2', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '11-19': [['1', '1', '3', '3', '5', '5', '@'],
    ['4', '1', '3', '3', '@', '5', '@'],
    ['4', '1', '1', '3', '5', '5', '6'],
    ['4', '4', '4', '2', '2', '2', '6'],
    ['8', '8', '2', '2', '@', '6', '6'],
    ['8', '8', '7', '7', '7', '7', '6'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '11-2': [['4', '4', '4', '7', '7', '2', '@'],
    ['5', '5', '4', '7', '@', '2', '@'],
    ['5', '@', '4', '7', '2', '2', '6'],
    ['5', '5', '1', '7', '2', '6', '6'],
    ['1', '1', '1', '8', '8', '8', '6'],
    ['1', '3', '3', '8', '8', '8', '6'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '11-20': [['2', '2', '7', '7', '7', '7', '@'],
    ['1', '2', '2', '2', '@', '7', '@'],
    ['1', '1', '1', '6', '6', '6', '6'],
    ['8', '8', '1', '3', '6', '5', '5'],
    ['8', '8', '4', '3', '3', '@', '5'],
    ['8', '8', '4', '3', '3', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '11-21': [['1', '1', '7', '7', '7', '7', '@'],
    ['2', '1', '5', '5', '@', '7', '@'],
    ['2', '1', '1', '5', '8', '8', '8'],
    ['2', '2', '5', '5', '8', '8', '8'],
    ['3', '2', '4', '4', '4', '6', '@'],
    ['3', '3', '4', '6', '6', '6', '6'],
    ['3', '3', '4', '@', '@', '@', '@']],
  '11-22': [['1', '1', '3', '3', '5', '5', '@'],
    ['4', '1', '3', '3', '@', '5', '@'],
    ['4', '1', '1', '3', '5', '5', '7'],
    ['4', '4', '4', '7', '7', '7', '7'],
    ['6', '6', '6', '6', '8', '8', '8'],
    ['@', '6', '2', '2', '8', '8', '8'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '11-23': [['1', '1', '3', '3', '5', '5', '@'],
    ['2', '1', '3', '3', '@', '5', '@'],
    ['2', '1', '1', '3', '5', '5', '6'],
    ['2', '2', '8', '8', '8', '6', '6'],
    ['4', '2', '8', '8', '8', '7', '6'],
    ['4', '@', '7', '7', '7', '7', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '11-24': [['1', '1', '7', '7', '7', '7', '@'],
    ['6', '1', '5', '5', '@', '7', '@'],
    ['6', '1', '1', '5', '4', '4', '4'],
    ['6', '6', '5', '5', '4', '8', '8'],
    ['6', '2', '2', '2', '4', '8', '8'],
    ['3', '3', '@', '2', '2', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '11-25': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '5', '@', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '6'],
    ['4', '4', '4', '2', '3', '6', '6'],
    ['8', '8', '2', '2', '3', '3', '6'],
    ['8', '8', '2', '@', '3', '3', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '11-26': [['2', '2', '7', '7', '7', '7', '@'],
    ['1', '2', '2', '2', '@', '7', '@'],
    ['1', '1', '1', '6', '4', '4', '4'],
    ['3', '3', '1', '6', '4', '8', '8'],
    ['3', '3', '6', '6', '4', '8', '8'],
    ['5', '3', '5', '6', '@', '8', '8'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '11-27': [['1', '1', '7', '7', '7', '7', '@'],
    ['6', '1', '5', '5', '@', '7', '@'],
    ['6', '1', '1', '5', '4', '4', '4'],
    ['6', '6', '5', '5', '4', '3', '3'],
    ['6', '2', '2', '2', '4', '3', '3'],
    ['8', '8', '8', '2', '2', '@', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-28': [['1', '1', '7', '7', '7', '7', '@'],
    ['6', '1', '5', '5', '@', '7', '@'],
    ['6', '1', '1', '5', '4', '4', '4'],
    ['6', '6', '5', '5', '3', '3', '4'],
    ['6', '2', '2', '2', '3', '3', '4'],
    ['8', '8', '8', '2', '2', '3', '@'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-29': [['1', '1', '7', '7', '7', '7', '@'],
    ['6', '1', '5', '5', '@', '7', '@'],
    ['6', '1', '1', '5', '4', '4', '4'],
    ['6', '6', '5', '5', '4', '8', '8'],
    ['6', '2', '2', '2', '4', '8', '8'],
    ['3', '3', '3', '2', '2', '8', '8'],
    ['@', '3', '3', '@', '@', '@', '@']],
  '11-3': [['6', '6', '6', '6', '1', '1', '@'],
    ['8', '8', '6', '2', '@', '1', '@'],
    ['8', '8', '@', '2', '7', '1', '1'],
    ['8', '8', '2', '2', '7', '3', '3'],
    ['4', '5', '2', '5', '7', '3', '3'],
    ['4', '5', '5', '5', '7', '7', '3'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '11-30': [['2', '2', '7', '7', '7', '7', '@'],
    ['6', '2', '2', '2', '@', '7', '@'],
    ['6', '6', '3', '3', '3', '8', '8'],
    ['6', '1', '3', '3', '4', '8', '8'],
    ['6', '1', '1', '1', '4', '8', '8'],
    ['5', '5', '5', '1', '4', '4', '4'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '11-31': [['1', '1', '7', '7', '7', '7', '@'],
    ['2', '1', '7', '5', '@', '5', '@'],
    ['2', '1', '1', '5', '5', '5', '6'],
    ['2', '2', '4', '4', '4', '6', '6'],
    ['3', '2', '4', '8', '8', '8', '6'],
    ['3', '3', '4', '8', '8', '8', '6'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '11-4': [['2', '2', '7', '7', '7', '7', '@'],
    ['6', '2', '2', '2', '@', '7', '@'],
    ['6', '5', '5', '@', '4', '4', '4'],
    ['6', '6', '5', '3', '1', '1', '4'],
    ['6', '5', '5', '3', '3', '1', '4'],
    ['8', '8', '8', '3', '3', '1', '1'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-5': [['2', '2', '7', '7', '7', '7', '@'],
    ['1', '2', '2', '2', '@', '7', '@'],
    ['1', '1', '1', '6', '@', '8', '8'],
    ['3', '3', '1', '6', '4', '8', '8'],
    ['3', '3', '6', '6', '4', '8', '8'],
    ['5', '3', '5', '6', '4', '4', '4'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '11-6': [['2', '1', '1', '5', '5', '5', '@'],
    ['2', '2', '1', '5', '@', '5', '@'],
    ['4', '2', '1', '1', '6', '@', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '3', '3', '3', '7'],
    ['8', '8', '8', '3', '3', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-7': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '5', '@', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '@'],
    ['4', '4', '4', '2', '3', '3', '3'],
    ['8', '8', '2', '2', '6', '3', '3'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '11-8': [['7', '7', '7', '7', '1', '1', '@'],
    ['7', '4', '4', '4', '@', '1', '@'],
    ['5', '5', '2', '4', '6', '1', '1'],
    ['@', '5', '2', '4', '6', '6', '3'],
    ['5', '5', '2', '2', '6', '3', '3'],
    ['8', '8', '8', '2', '6', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '11-9': [['3', '3', '7', '7', '7', '7', '@'],
    ['3', '3', '2', '2', '@', '7', '@'],
    ['4', '3', '1', '2', '2', '2', '6'],
    ['4', '@', '1', '1', '1', '6', '6'],
    ['4', '4', '4', '5', '1', '5', '6'],
    ['8', '8', '8', '5', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '12-1': [['2', '7', '7', '4', '4', '4', '@'],
    ['2', '2', '7', '4', '1', '@', '@'],
    ['@', '2', '7', '4', '1', '1', '1'],
    ['6', '2', '7', '8', '8', '3', '1'],
    ['6', '5', '5', '8', '8', '3', '3'],
    ['6', '6', '5', '8', '8', '3', '3'],
    ['6', '5', '5', '@', '@', '@', '@']],
  '12-10': [['1', '1', '3', '3', '5', '5', '@'],
    ['2', '1', '3', '3', '5', '@', '@'],
    ['2', '1', '1', '3', '5', '5', '7'],
    ['2', '2', '@', '8', '8', '8', '7'],
    ['4', '2', '6', '8', '8', '8', '7'],
    ['4', '6', '6', '6', '6', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '12-11': [['1', '1', '3', '3', '5', '5', '@'],
    ['4', '1', '3', '3', '5', '@', '@'],
    ['4', '1', '1', '3', '5', '5', '6'],
    ['4', '4', '4', '@', '2', '2', '6'],
    ['8', '8', '2', '2', '2', '6', '6'],
    ['8', '8', '7', '7', '7', '7', '6'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '12-12': [['2', '2', '6', '6', '6', '6', '@'],
    ['1', '2', '2', '2', '6', '@', '@'],
    ['1', '1', '1', '7', '7', '3', '3'],
    ['8', '8', '1', '7', '@', '3', '3'],
    ['8', '8', '4', '7', '5', '3', '5'],
    ['8', '8', '4', '7', '5', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '12-13': [['1', '1', '3', '3', '7', '7', '@'],
    ['4', '1', '3', '3', '7', '@', '@'],
    ['4', '1', '1', '3', '7', '5', '5'],
    ['4', '4', '4', '2', '7', '@', '5'],
    ['8', '8', '2', '2', '6', '5', '5'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '12-14': [['1', '1', '3', '3', '7', '7', '@'],
    ['4', '1', '3', '3', '7', '@', '@'],
    ['4', '1', '1', '3', '7', '5', '5'],
    ['4', '4', '4', '2', '7', '5', '@'],
    ['8', '8', '2', '2', '6', '5', '5'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '12-15': [['1', '1', '6', '6', '6', '6', '@'],
    ['2', '1', '5', '5', '6', '@', '@'],
    ['2', '1', '1', '5', '4', '3', '3'],
    ['2', '2', '5', '5', '4', '3', '3'],
    ['@', '2', '4', '4', '4', '3', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '12-16': [['2', '2', '6', '6', '6', '6', '@'],
    ['7', '2', '2', '2', '6', '@', '@'],
    ['7', '7', '7', '7', '4', '4', '4'],
    ['5', '5', '5', '3', '1', '1', '4'],
    ['5', '@', '5', '3', '3', '1', '4'],
    ['8', '8', '8', '3', '3', '1', '1'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '12-17': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '2', '2', '@', '@'],
    ['4', '1', '1', '3', '2', '2', '2'],
    ['4', '4', '4', '3', '3', '8', '8'],
    ['5', '5', '@', '3', '3', '8', '8'],
    ['5', '6', '6', '6', '6', '8', '8'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '12-18': [['2', '2', '6', '6', '6', '6', '@'],
    ['1', '2', '2', '2', '6', '@', '@'],
    ['1', '1', '1', '4', '4', '4', '7'],
    ['3', '3', '1', '5', '5', '4', '7'],
    ['3', '3', '3', '@', '5', '4', '7'],
    ['8', '8', '8', '5', '5', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '12-19': [['1', '1', '3', '3', '5', '5', '@'],
    ['4', '1', '3', '3', '5', '@', '@'],
    ['4', '1', '1', '3', '5', '5', '6'],
    ['4', '4', '4', '2', '2', '2', '6'],
    ['8', '8', '2', '2', '@', '6', '6'],
    ['8', '8', '7', '7', '7', '7', '6'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '12-2': [['2', '2', '6', '6', '6', '6', '@'],
    ['4', '2', '2', '2', '6', '@', '@'],
    ['4', '@', '5', '5', '3', '3', '7'],
    ['4', '4', '4', '5', '3', '3', '7'],
    ['8', '8', '5', '5', '1', '3', '7'],
    ['8', '8', '1', '1', '1', '7', '7'],
    ['8', '8', '1', '@', '@', '@', '@']],
  '12-20': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '2', '2', '6', '@', '@'],
    ['4', '1', '1', '2', '2', '2', '7'],
    ['4', '4', '4', '7', '7', '7', '7'],
    ['8', '8', '3', '3', '5', '@', '5'],
    ['8', '8', '3', '3', '5', '5', '5'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '12-21': [['2', '2', '6', '6', '6', '6', '@'],
    ['7', '2', '2', '2', '6', '@', '@'],
    ['7', '7', '7', '7', '4', '4', '4'],
    ['3', '3', '1', '1', '4', '5', '5'],
    ['3', '3', '3', '1', '4', '5', '@'],
    ['8', '8', '8', '1', '1', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '12-22': [['1', '1', '3', '3', '7', '7', '@'],
    ['4', '1', '3', '3', '7', '@', '@'],
    ['4', '1', '1', '3', '7', '8', '8'],
    ['4', '4', '4', '2', '7', '8', '8'],
    ['5', '5', '2', '2', '6', '8', '8'],
    ['@', '5', '2', '6', '6', '6', '6'],
    ['5', '5', '2', '@', '@', '@', '@']],
  '12-23': [['1', '1', '3', '3', '7', '7', '@'],
    ['4', '1', '3', '3', '7', '@', '@'],
    ['4', '1', '1', '3', '7', '8', '8'],
    ['4', '4', '4', '2', '7', '8', '8'],
    ['5', '5', '2', '2', '6', '8', '8'],
    ['5', '@', '2', '6', '6', '6', '6'],
    ['5', '5', '2', '@', '@', '@', '@']],
  '12-24': [['3', '3', '7', '7', '7', '7', '@'],
    ['3', '3', '7', '1', '1', '@', '@'],
    ['2', '3', '8', '8', '1', '5', '5'],
    ['2', '2', '8', '8', '1', '1', '5'],
    ['4', '2', '8', '8', '6', '5', '5'],
    ['4', '2', '@', '6', '6', '6', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '12-25': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '3', '3', '@', '@'],
    ['4', '1', '1', '3', '3', '3', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['8', '8', '2', '2', '5', '6', '6'],
    ['8', '8', '2', '@', '5', '5', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '12-26': [['1', '1', '6', '6', '6', '6', '@'],
    ['2', '1', '5', '5', '6', '@', '@'],
    ['2', '1', '1', '5', '8', '8', '7'],
    ['2', '2', '5', '5', '8', '8', '7'],
    ['4', '2', '3', '3', '8', '8', '7'],
    ['4', '3', '3', '3', '@', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '12-27': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '2', '2', '6', '@', '@'],
    ['4', '1', '1', '2', '2', '2', '7'],
    ['4', '4', '4', '7', '7', '7', '7'],
    ['8', '8', '3', '3', '5', '5', '5'],
    ['8', '8', '3', '3', '5', '@', '5'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '12-28': [['1', '1', '6', '6', '6', '6', '@'],
    ['2', '1', '5', '5', '6', '@', '@'],
    ['2', '1', '1', '5', '4', '8', '8'],
    ['2', '2', '5', '5', '4', '8', '8'],
    ['3', '2', '4', '4', '4', '8', '8'],
    ['3', '3', '7', '7', '7', '7', '@'],
    ['3', '3', '7', '@', '@', '@', '@']],
  '12-29': [['2', '2', '6', '6', '6', '6', '@'],
    ['7', '2', '2', '2', '6', '@', '@'],
    ['7', '7', '7', '7', '3', '3', '3'],
    ['4', '4', '4', '1', '1', '3', '3'],
    ['4', '5', '5', '1', '8', '8', '8'],
    ['4', '5', '1', '1', '8', '8', '8'],
    ['@', '5', '5', '@', '@', '@', '@']],
  '12-3': [['2', '2', '6', '6', '6', '6', '@'],
    ['7', '2', '2', '2', '6', '@', '@'],
    ['7', '5', '@', '5', '4', '4', '4'],
    ['7', '5', '5', '5', '1', '1', '4'],
    ['7', '7', '8', '8', '8', '1', '4'],
    ['3', '3', '8', '8', '8', '1', '1'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '12-30': [['2', '2', '6', '6', '6', '6', '@'],
    ['7', '2', '2', '2', '6', '@', '@'],
    ['7', '7', '7', '7', '4', '4', '4'],
    ['8', '8', '8', '3', '1', '1', '4'],
    ['8', '8', '8', '3', '3', '1', '4'],
    ['5', '5', '5', '3', '3', '1', '1'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '12-31': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '2', '2', '6', '@', '@'],
    ['4', '1', '1', '2', '2', '2', '7'],
    ['4', '4', '4', '7', '7', '7', '7'],
    ['5', '5', '3', '3', '8', '8', '8'],
    ['5', '3', '3', '3', '8', '8', '8'],
    ['5', '5', '@', '@', '@', '@', '@']],
  '12-4': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '7', '2', '2', '@', '@'],
    ['4', '1', '1', '@', '2', '2', '2'],
    ['4', '4', '4', '5', '5', '8', '8'],
    ['6', '6', '6', '6', '5', '8', '8'],
    ['3', '3', '6', '5', '5', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '12-5': [['1', '1', '6', '6', '6', '6', '@'],
    ['2', '1', '5', '5', '6', '@', '@'],
    ['2', '1', '1', '5', '@', '7', '7'],
    ['2', '2', '5', '5', '8', '8', '7'],
    ['4', '2', '3', '3', '8', '8', '7'],
    ['4', '3', '3', '3', '8', '8', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '12-6': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '7', '7', '6', '@', '@'],
    ['4', '1', '1', '7', '5', '@', '5'],
    ['4', '4', '4', '7', '5', '5', '5'],
    ['3', '3', '3', '7', '8', '8', '8'],
    ['3', '3', '2', '2', '8', '8', '8'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '12-7': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '2', '2', '6', '@', '@'],
    ['4', '1', '1', '2', '2', '2', '@'],
    ['4', '4', '4', '5', '5', '8', '8'],
    ['7', '7', '7', '7', '5', '8', '8'],
    ['7', '3', '3', '5', '5', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '12-8': [['7', '7', '7', '7', '1', '1', '@'],
    ['7', '2', '2', '2', '1', '@', '@'],
    ['2', '2', '6', '1', '1', '3', '3'],
    ['@', '6', '6', '6', '6', '3', '3'],
    ['4', '8', '8', '8', '5', '3', '5'],
    ['4', '8', '8', '8', '5', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '12-9': [['1', '1', '6', '6', '6', '6', '@'],
    ['7', '1', '5', '5', '6', '@', '@'],
    ['7', '1', '1', '5', '4', '4', '4'],
    ['7', '@', '5', '5', '4', '3', '3'],
    ['7', '7', '2', '2', '4', '3', '3'],
    ['8', '8', '8', '2', '2', '2', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-1': [['2', '@', '4', '4', '4', '6', '@'],
    ['2', '2', '8', '8', '4', '6', '@'],
    ['@', '2', '8', '8', '4', '6', '6'],
    ['1', '2', '8', '8', '5', '6', '5'],
    ['1', '1', '1', '7', '5', '5', '5'],
    ['3', '3', '1', '7', '7', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '2-10': [['2', '@', '3', '3', '1', '1', '@'],
    ['2', '2', '3', '3', '3', '1', '@'],
    ['4', '2', '7', '7', '6', '1', '1'],
    ['4', '2', '@', '7', '6', '5', '5'],
    ['4', '4', '4', '7', '6', '6', '5'],
    ['8', '8', '8', '7', '6', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-11': [['2', '@', '6', '5', '5', '5', '@'],
    ['2', '2', '6', '5', '1', '5', '@'],
    ['4', '2', '6', '6', '1', '1', '1'],
    ['4', '2', '6', '@', '3', '3', '1'],
    ['4', '4', '4', '3', '3', '3', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-12': [['6', '@', '4', '4', '4', '2', '@'],
    ['6', '5', '5', '7', '4', '2', '@'],
    ['6', '6', '5', '7', '4', '2', '2'],
    ['6', '5', '5', '7', '@', '3', '2'],
    ['8', '8', '7', '7', '1', '3', '3'],
    ['8', '8', '1', '1', '1', '3', '3'],
    ['8', '8', '1', '@', '@', '@', '@']],
  '2-13': [['2', '@', '6', '5', '5', '5', '@'],
    ['2', '2', '6', '5', '1', '5', '@'],
    ['4', '2', '6', '6', '1', '1', '1'],
    ['4', '2', '6', '3', '3', '@', '1'],
    ['4', '4', '4', '3', '3', '3', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-14': [['6', '@', '3', '3', '1', '1', '@'],
    ['6', '3', '3', '3', '2', '1', '@'],
    ['6', '6', '7', '7', '2', '1', '1'],
    ['6', '8', '8', '7', '2', '2', '@'],
    ['4', '8', '8', '7', '5', '2', '5'],
    ['4', '8', '8', '7', '5', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '2-15': [['6', '@', '4', '4', '4', '2', '@'],
    ['6', '3', '3', '3', '4', '2', '@'],
    ['6', '6', '3', '3', '4', '2', '2'],
    ['6', '1', '7', '7', '7', '7', '2'],
    ['@', '1', '1', '1', '5', '7', '5'],
    ['8', '8', '8', '1', '5', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-16': [['2', '@', '3', '3', '8', '8', '@'],
    ['2', '2', '3', '3', '8', '8', '@'],
    ['7', '2', '1', '3', '8', '8', '6'],
    ['7', '2', '1', '1', '1', '6', '6'],
    ['7', '@', '4', '5', '1', '5', '6'],
    ['7', '7', '4', '5', '5', '5', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '2-17': [['6', '@', '7', '7', '7', '7', '@'],
    ['6', '5', '5', '3', '3', '7', '@'],
    ['6', '6', '5', '3', '3', '1', '1'],
    ['6', '5', '5', '2', '3', '1', '4'],
    ['8', '8', '@', '2', '1', '1', '4'],
    ['8', '8', '2', '2', '4', '4', '4'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '2-18': [['2', '@', '6', '6', '6', '6', '@'],
    ['2', '2', '5', '5', '6', '3', '@'],
    ['4', '2', '5', '1', '1', '3', '3'],
    ['4', '2', '5', '5', '1', '3', '3'],
    ['4', '4', '4', '@', '1', '1', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-19': [['6', '@', '7', '7', '1', '1', '@'],
    ['6', '5', '5', '7', '2', '1', '@'],
    ['6', '6', '5', '7', '2', '1', '1'],
    ['6', '5', '5', '7', '2', '2', '4'],
    ['8', '8', '3', '3', '@', '2', '4'],
    ['8', '8', '3', '3', '4', '4', '4'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '2-2': [['6', '@', '3', '3', '5', '5', '@'],
    ['6', '6', '3', '3', '3', '5', '@'],
    ['6', '@', '2', '1', '5', '5', '7'],
    ['6', '2', '2', '1', '1', '1', '7'],
    ['4', '2', '8', '8', '8', '1', '7'],
    ['4', '2', '8', '8', '8', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '2-20': [['2', '@', '6', '5', '5', '5', '@'],
    ['2', '2', '6', '5', '1', '5', '@'],
    ['4', '2', '6', '6', '1', '1', '1'],
    ['4', '2', '6', '3', '3', '3', '1'],
    ['4', '4', '4', '3', '3', '@', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-21': [['2', '@', '6', '6', '6', '6', '@'],
    ['2', '2', '5', '5', '6', '3', '@'],
    ['4', '2', '5', '1', '1', '3', '3'],
    ['4', '2', '5', '5', '1', '3', '3'],
    ['4', '4', '4', '7', '1', '1', '@'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-22': [['2', '@', '6', '5', '5', '5', '@'],
    ['2', '2', '6', '5', '1', '5', '@'],
    ['4', '2', '6', '6', '1', '1', '1'],
    ['4', '2', '6', '8', '8', '8', '1'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['@', '3', '3', '7', '7', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '2-23': [['2', '@', '7', '7', '1', '1', '@'],
    ['2', '2', '7', '8', '8', '1', '@'],
    ['6', '2', '7', '8', '8', '1', '1'],
    ['6', '2', '7', '8', '8', '5', '5'],
    ['6', '6', '4', '3', '3', '3', '5'],
    ['6', '@', '4', '3', '3', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '2-24': [['2', '@', '6', '5', '5', '5', '@'],
    ['2', '2', '6', '5', '1', '5', '@'],
    ['4', '2', '6', '6', '1', '1', '1'],
    ['4', '2', '6', '8', '8', '8', '1'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '3', '@', '7', '7', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '2-25': [['2', '@', '1', '4', '4', '4', '@'],
    ['2', '2', '1', '1', '1', '4', '@'],
    ['6', '2', '5', '5', '1', '4', '7'],
    ['6', '2', '5', '7', '7', '7', '7'],
    ['6', '6', '5', '5', '8', '8', '8'],
    ['6', '3', '3', '@', '8', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '2-26': [['2', '@', '6', '8', '8', '8', '@'],
    ['2', '2', '6', '8', '8', '8', '@'],
    ['4', '2', '6', '6', '5', '5', '7'],
    ['4', '2', '6', '1', '1', '5', '7'],
    ['4', '4', '4', '1', '5', '5', '7'],
    ['3', '3', '1', '1', '@', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '2-27': [['2', '@', '7', '7', '7', '7', '@'],
    ['2', '2', '3', '3', '3', '7', '@'],
    ['4', '2', '3', '3', '5', '5', '6'],
    ['4', '2', '1', '1', '5', '6', '6'],
    ['4', '4', '4', '1', '5', '5', '6'],
    ['8', '8', '8', '1', '1', '@', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-28': [['6', '@', '1', '1', '3', '3', '@'],
    ['6', '5', '5', '1', '3', '3', '@'],
    ['6', '6', '5', '1', '1', '3', '4'],
    ['6', '5', '5', '2', '2', '2', '4'],
    ['8', '8', '2', '2', '4', '4', '4'],
    ['8', '8', '7', '7', '7', '7', '@'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '2-29': [['2', '@', '1', '1', '3', '3', '@'],
    ['2', '2', '4', '1', '3', '3', '@'],
    ['7', '2', '4', '1', '1', '3', '6'],
    ['7', '2', '4', '4', '4', '6', '6'],
    ['7', '5', '5', '8', '8', '8', '6'],
    ['7', '7', '5', '8', '8', '8', '6'],
    ['@', '5', '5', '@', '@', '@', '@']],
  '2-3': [['6', '@', '2', '2', '2', '1', '@'],
    ['6', '2', '2', '1', '1', '1', '@'],
    ['6', '6', '@', '1', '7', '3', '3'],
    ['6', '7', '7', '7', '7', '3', '3'],
    ['4', '8', '8', '8', '5', '3', '5'],
    ['4', '8', '8', '8', '5', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '2-30': [['6', '@', '3', '3', '1', '1', '@'],
    ['6', '6', '3', '3', '3', '1', '@'],
    ['6', '7', '7', '7', '7', '1', '1'],
    ['6', '7', '2', '2', '4', '4', '4'],
    ['2', '2', '2', '8', '8', '8', '4'],
    ['5', '5', '5', '8', '8', '8', '4'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '2-31': [['2', '@', '6', '5', '5', '5', '@'],
    ['2', '2', '6', '5', '1', '5', '@'],
    ['4', '2', '6', '6', '1', '1', '1'],
    ['4', '2', '6', '8', '8', '8', '1'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '3', '3', '7', '7', '7', '7'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '2-4': [['2', '@', '7', '7', '7', '7', '@'],
    ['2', '2', '7', '3', '3', '3', '@'],
    ['4', '2', '1', '@', '3', '3', '6'],
    ['4', '2', '1', '1', '1', '6', '6'],
    ['4', '4', '4', '5', '1', '5', '6'],
    ['8', '8', '8', '5', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-5': [['2', '@', '4', '4', '4', '1', '@'],
    ['2', '2', '4', '1', '1', '1', '@'],
    ['6', '2', '4', '1', '@', '8', '8'],
    ['6', '2', '5', '5', '5', '8', '8'],
    ['6', '6', '5', '7', '5', '8', '8'],
    ['6', '3', '3', '7', '7', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '2-6': [['2', '@', '7', '7', '7', '7', '@'],
    ['2', '2', '7', '3', '3', '3', '@'],
    ['4', '2', '1', '3', '3', '@', '6'],
    ['4', '2', '1', '1', '1', '6', '6'],
    ['4', '4', '4', '5', '1', '5', '6'],
    ['8', '8', '8', '5', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-7': [['2', '@', '6', '5', '5', '7', '@'],
    ['2', '2', '6', '6', '5', '7', '@'],
    ['4', '2', '6', '5', '5', '7', '@'],
    ['4', '2', '6', '1', '1', '7', '7'],
    ['4', '4', '4', '1', '8', '8', '8'],
    ['3', '3', '1', '1', '8', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '2-8': [['1', '@', '4', '4', '4', '7', '@'],
    ['1', '1', '1', '2', '4', '7', '@'],
    ['5', '5', '1', '2', '4', '7', '6'],
    ['@', '5', '2', '2', '7', '7', '6'],
    ['5', '5', '2', '3', '3', '6', '6'],
    ['8', '8', '8', '3', '3', '3', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '2-9': [['6', '@', '2', '2', '2', '1', '@'],
    ['6', '2', '2', '1', '1', '1', '@'],
    ['6', '6', '5', '1', '5', '3', '3'],
    ['6', '@', '5', '5', '5', '3', '3'],
    ['8', '8', '4', '4', '4', '3', '7'],
    ['8', '8', '4', '7', '7', '7', '7'],
    ['8', '8', '4', '@', '@', '@', '@']],
  '3-1': [['3', '3', '@', '8', '8', '8', '@'],
    ['3', '3', '2', '8', '8', '8', '@'],
    ['@', '3', '2', '2', '5', '5', '6'],
    ['4', '4', '4', '2', '5', '6', '6'],
    ['4', '1', '1', '2', '5', '5', '6'],
    ['4', '1', '7', '7', '7', '7', '6'],
    ['1', '1', '7', '@', '@', '@', '@']],
  '3-10': [['1', '1', '@', '2', '2', '2', '@'],
    ['6', '1', '2', '2', '5', '5', '@'],
    ['6', '1', '1', '4', '5', '7', '7'],
    ['6', '6', '@', '4', '5', '5', '7'],
    ['6', '4', '4', '4', '3', '3', '7'],
    ['8', '8', '8', '3', '3', '3', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-11': [['1', '1', '@', '3', '3', '3', '@'],
    ['4', '1', '2', '2', '3', '3', '@'],
    ['4', '1', '1', '2', '2', '2', '6'],
    ['4', '4', '4', '@', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['8', '8', '8', '7', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-12': [['2', '2', '@', '3', '3', '3', '@'],
    ['6', '2', '2', '2', '3', '3', '@'],
    ['6', '5', '5', '7', '7', '7', '7'],
    ['6', '6', '5', '7', '@', '1', '4'],
    ['6', '5', '5', '1', '1', '1', '4'],
    ['8', '8', '8', '1', '4', '4', '4'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-13': [['2', '2', '@', '3', '3', '3', '@'],
    ['6', '2', '2', '2', '3', '3', '@'],
    ['6', '5', '5', '1', '1', '7', '7'],
    ['6', '6', '5', '4', '1', '@', '7'],
    ['6', '5', '5', '4', '1', '1', '7'],
    ['8', '8', '8', '4', '4', '4', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-14': [['1', '1', '@', '7', '7', '6', '@'],
    ['2', '1', '5', '5', '7', '6', '@'],
    ['2', '1', '1', '5', '7', '6', '6'],
    ['2', '2', '5', '5', '7', '6', '@'],
    ['4', '2', '3', '3', '8', '8', '8'],
    ['4', '3', '3', '3', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '3-15': [['1', '1', '@', '6', '3', '3', '@'],
    ['2', '1', '6', '6', '3', '3', '@'],
    ['2', '1', '1', '6', '3', '7', '7'],
    ['2', '2', '5', '6', '5', '4', '7'],
    ['@', '2', '5', '5', '5', '4', '7'],
    ['8', '8', '8', '4', '4', '4', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-16': [['1', '1', '@', '4', '4', '4', '@'],
    ['6', '1', '5', '5', '2', '4', '@'],
    ['6', '1', '1', '5', '2', '4', '7'],
    ['6', '6', '5', '5', '2', '2', '7'],
    ['6', '@', '8', '8', '8', '2', '7'],
    ['3', '3', '8', '8', '8', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '3-17': [['1', '1', '@', '3', '3', '3', '@'],
    ['7', '1', '2', '2', '3', '3', '@'],
    ['7', '1', '1', '2', '2', '2', '6'],
    ['7', '4', '4', '4', '5', '5', '6'],
    ['7', '7', '@', '4', '5', '6', '6'],
    ['8', '8', '8', '4', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-18': [['1', '1', '@', '3', '3', '3', '@'],
    ['2', '1', '5', '5', '3', '3', '@'],
    ['2', '1', '1', '5', '8', '8', '7'],
    ['2', '2', '5', '5', '8', '8', '7'],
    ['4', '2', '6', '@', '8', '8', '7'],
    ['4', '6', '6', '6', '6', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '3-19': [['2', '2', '@', '4', '4', '4', '@'],
    ['1', '2', '2', '2', '3', '4', '@'],
    ['1', '1', '1', '3', '3', '4', '6'],
    ['7', '7', '1', '3', '3', '6', '6'],
    ['7', '8', '8', '5', '@', '5', '6'],
    ['7', '8', '8', '5', '5', '5', '6'],
    ['7', '8', '8', '@', '@', '@', '@']],
  '3-2': [['2', '2', '@', '7', '7', '6', '@'],
    ['4', '2', '2', '2', '7', '6', '@'],
    ['4', '@', '5', '5', '7', '6', '6'],
    ['4', '4', '4', '5', '7', '6', '3'],
    ['8', '8', '5', '5', '1', '3', '3'],
    ['8', '8', '1', '1', '1', '3', '3'],
    ['8', '8', '1', '@', '@', '@', '@']],
  '3-20': [['1', '1', '@', '6', '7', '2', '@'],
    ['4', '1', '6', '6', '7', '2', '@'],
    ['4', '1', '1', '6', '7', '2', '2'],
    ['4', '4', '4', '6', '7', '7', '2'],
    ['8', '8', '3', '3', '5', '@', '5'],
    ['8', '8', '3', '3', '5', '5', '5'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '3-21': [['2', '2', '@', '3', '3', '3', '@'],
    ['1', '2', '2', '2', '3', '3', '@'],
    ['1', '1', '1', '7', '7', '7', '7'],
    ['8', '8', '1', '5', '5', '5', '7'],
    ['8', '8', '4', '5', '6', '5', '@'],
    ['8', '8', '4', '6', '6', '6', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '3-22': [['1', '1', '@', '6', '7', '2', '@'],
    ['4', '1', '6', '6', '7', '2', '@'],
    ['4', '1', '1', '6', '7', '2', '2'],
    ['4', '4', '4', '6', '7', '7', '2'],
    ['5', '5', '3', '3', '8', '8', '8'],
    ['@', '5', '3', '3', '8', '8', '8'],
    ['5', '5', '3', '@', '@', '@', '@']],
  '3-23': [['1', '1', '@', '6', '3', '3', '@'],
    ['4', '1', '6', '6', '3', '3', '@'],
    ['4', '1', '1', '6', '5', '3', '5'],
    ['4', '4', '4', '6', '5', '5', '5'],
    ['7', '7', '7', '7', '8', '8', '8'],
    ['7', '@', '2', '2', '8', '8', '8'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '3-24': [['2', '2', '@', '4', '4', '4', '@'],
    ['1', '2', '2', '2', '3', '4', '@'],
    ['1', '1', '1', '3', '3', '4', '6'],
    ['7', '7', '1', '3', '3', '6', '6'],
    ['7', '5', '5', '8', '8', '8', '6'],
    ['7', '5', '@', '8', '8', '8', '6'],
    ['7', '5', '5', '@', '@', '@', '@']],
  '3-25': [['1', '1', '@', '3', '3', '3', '@'],
    ['4', '1', '2', '2', '3', '3', '@'],
    ['4', '1', '1', '2', '2', '2', '6'],
    ['4', '4', '4', '7', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['8', '8', '8', '@', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-26': [['2', '2', '@', '4', '4', '4', '@'],
    ['6', '2', '2', '2', '3', '4', '@'],
    ['6', '5', '5', '3', '3', '4', '7'],
    ['6', '6', '5', '3', '3', '1', '7'],
    ['6', '5', '5', '1', '1', '1', '7'],
    ['8', '8', '8', '1', '@', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-27': [['1', '1', '@', '3', '3', '3', '@'],
    ['2', '1', '5', '5', '3', '3', '@'],
    ['2', '1', '1', '5', '8', '8', '8'],
    ['2', '2', '5', '5', '8', '8', '8'],
    ['4', '2', '6', '7', '7', '7', '7'],
    ['4', '6', '6', '6', '6', '@', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '3-28': [['1', '1', '@', '6', '3', '3', '@'],
    ['4', '1', '6', '6', '3', '3', '@'],
    ['4', '1', '1', '6', '3', '5', '5'],
    ['4', '4', '4', '6', '2', '2', '5'],
    ['8', '8', '2', '2', '2', '5', '5'],
    ['8', '8', '7', '7', '7', '7', '@'],
    ['8', '8', '7', '@', '@', '@', '@']],
  '3-29': [['3', '3', '@', '2', '1', '1', '@'],
    ['3', '3', '2', '2', '4', '1', '@'],
    ['6', '3', '2', '7', '4', '1', '1'],
    ['6', '6', '2', '7', '4', '4', '4'],
    ['6', '5', '5', '7', '8', '8', '8'],
    ['6', '5', '7', '7', '8', '8', '8'],
    ['@', '5', '5', '@', '@', '@', '@']],
  '3-3': [['3', '3', '@', '2', '2', '2', '@'],
    ['3', '3', '2', '2', '8', '8', '@'],
    ['1', '3', '@', '4', '8', '8', '7'],
    ['1', '1', '1', '4', '8', '8', '7'],
    ['5', '5', '1', '4', '4', '4', '7'],
    ['5', '6', '6', '6', '6', '7', '7'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '3-30': [['3', '3', '@', '2', '1', '1', '@'],
    ['3', '3', '3', '2', '4', '1', '@'],
    ['8', '8', '2', '2', '4', '1', '1'],
    ['8', '8', '2', '6', '4', '4', '4'],
    ['8', '8', '6', '6', '6', '6', '7'],
    ['5', '5', '5', '7', '7', '7', '7'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '3-31': [['1', '1', '@', '4', '4', '4', '@'],
    ['6', '1', '5', '5', '2', '4', '@'],
    ['6', '1', '1', '5', '2', '4', '7'],
    ['6', '6', '5', '5', '2', '2', '7'],
    ['6', '3', '8', '8', '8', '2', '7'],
    ['3', '3', '8', '8', '8', '7', '7'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '3-4': [['1', '1', '@', '2', '2', '2', '@'],
    ['4', '1', '2', '2', '3', '3', '@'],
    ['4', '1', '1', '@', '3', '3', '3'],
    ['4', '4', '4', '6', '6', '6', '6'],
    ['7', '7', '7', '7', '5', '6', '5'],
    ['8', '8', '8', '7', '5', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-5': [['2', '2', '@', '3', '3', '3', '@'],
    ['1', '2', '2', '2', '3', '3', '@'],
    ['1', '1', '1', '6', '@', '7', '7'],
    ['8', '8', '1', '6', '5', '5', '7'],
    ['8', '8', '4', '6', '6', '5', '7'],
    ['8', '8', '4', '6', '5', '5', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '3-6': [['2', '2', '@', '3', '3', '3', '@'],
    ['6', '2', '2', '2', '3', '3', '@'],
    ['6', '6', '7', '7', '5', '@', '5'],
    ['6', '1', '1', '7', '5', '5', '5'],
    ['6', '1', '4', '7', '8', '8', '8'],
    ['1', '1', '4', '7', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '3-7': [['1', '1', '@', '4', '4', '4', '@'],
    ['6', '1', '5', '5', '7', '4', '@'],
    ['6', '1', '1', '5', '7', '4', '@'],
    ['6', '6', '5', '5', '7', '8', '8'],
    ['6', '2', '2', '7', '7', '8', '8'],
    ['3', '3', '2', '2', '2', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '3-8': [['2', '2', '@', '3', '3', '3', '@'],
    ['1', '2', '2', '2', '3', '3', '@'],
    ['1', '1', '1', '4', '4', '4', '7'],
    ['@', '6', '1', '5', '5', '4', '7'],
    ['6', '6', '6', '6', '5', '4', '7'],
    ['8', '8', '8', '5', '5', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '3-9': [['1', '1', '@', '3', '3', '3', '@'],
    ['7', '1', '5', '5', '3', '3', '@'],
    ['7', '1', '1', '5', '4', '4', '4'],
    ['7', '@', '5', '5', '2', '2', '4'],
    ['7', '7', '2', '2', '2', '6', '4'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-1': [['2', '7', '7', '@', '1', '1', '@'],
    ['2', '2', '7', '3', '3', '1', '@'],
    ['@', '2', '7', '3', '3', '1', '1'],
    ['6', '2', '7', '3', '4', '4', '4'],
    ['6', '5', '5', '8', '8', '8', '4'],
    ['6', '6', '5', '8', '8', '8', '4'],
    ['6', '5', '5', '@', '@', '@', '@']],
  '4-10': [['1', '1', '5', '@', '5', '4', '@'],
    ['6', '1', '5', '5', '5', '4', '@'],
    ['6', '1', '1', '4', '4', '4', '7'],
    ['6', '6', '@', '7', '7', '7', '7'],
    ['6', '2', '2', '2', '3', '3', '3'],
    ['8', '8', '8', '2', '2', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-11': [['4', '4', '4', '@', '1', '1', '@'],
    ['8', '8', '4', '3', '3', '1', '@'],
    ['8', '8', '4', '3', '3', '1', '1'],
    ['8', '8', '6', '@', '3', '2', '2'],
    ['5', '5', '6', '2', '2', '2', '7'],
    ['5', '6', '6', '7', '7', '7', '7'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '4-12': [['1', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '6'],
    ['2', '2', '7', '7', '@', '6', '6'],
    ['3', '2', '7', '8', '8', '8', '6'],
    ['3', '3', '7', '8', '8', '8', '6'],
    ['3', '3', '7', '@', '@', '@', '@']],
  '4-13': [['1', '1', '5', '@', '5', '4', '@'],
    ['6', '1', '5', '5', '5', '4', '@'],
    ['6', '1', '1', '4', '4', '4', '7'],
    ['6', '6', '2', '2', '2', '@', '7'],
    ['6', '2', '2', '3', '3', '3', '7'],
    ['8', '8', '8', '3', '3', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-14': [['1', '1', '2', '@', '7', '7', '@'],
    ['4', '1', '2', '2', '7', '6', '@'],
    ['4', '1', '1', '2', '7', '6', '6'],
    ['4', '4', '4', '2', '7', '6', '@'],
    ['8', '8', '3', '3', '5', '6', '5'],
    ['8', '8', '3', '3', '5', '5', '5'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '4-15': [['1', '1', '2', '@', '3', '3', '@'],
    ['4', '1', '2', '2', '3', '3', '@'],
    ['4', '1', '1', '2', '3', '7', '7'],
    ['4', '4', '4', '2', '5', '5', '7'],
    ['@', '6', '6', '6', '6', '5', '7'],
    ['8', '8', '8', '6', '5', '5', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-16': [['1', '1', '2', '@', '3', '3', '@'],
    ['6', '1', '2', '2', '3', '3', '@'],
    ['6', '1', '1', '2', '3', '7', '7'],
    ['6', '6', '5', '2', '5', '4', '7'],
    ['6', '@', '5', '5', '5', '4', '7'],
    ['8', '8', '8', '4', '4', '4', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-17': [['1', '1', '2', '@', '8', '8', '@'],
    ['4', '1', '2', '2', '8', '8', '@'],
    ['4', '1', '1', '2', '8', '8', '7'],
    ['4', '4', '4', '2', '3', '3', '7'],
    ['5', '5', '@', '3', '3', '3', '7'],
    ['5', '6', '6', '6', '6', '7', '7'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '4-18': [['1', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '7'],
    ['2', '2', '6', '7', '7', '7', '7'],
    ['3', '2', '6', '@', '8', '8', '8'],
    ['3', '3', '6', '6', '8', '8', '8'],
    ['3', '3', '6', '@', '@', '@', '@']],
  '4-19': [['1', '1', '5', '@', '5', '4', '@'],
    ['6', '1', '5', '5', '5', '4', '@'],
    ['6', '1', '1', '4', '4', '4', '3'],
    ['6', '6', '2', '2', '2', '3', '3'],
    ['6', '2', '2', '7', '@', '3', '3'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-2': [['4', '4', '4', '@', '1', '1', '@'],
    ['5', '5', '4', '8', '8', '1', '@'],
    ['5', '@', '4', '8', '8', '1', '1'],
    ['5', '5', '6', '8', '8', '2', '2'],
    ['3', '6', '6', '2', '2', '2', '7'],
    ['3', '3', '6', '7', '7', '7', '7'],
    ['3', '3', '6', '@', '@', '@', '@']],
  '4-20': [['1', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '6'],
    ['2', '2', '8', '8', '8', '6', '6'],
    ['3', '2', '8', '8', '8', '@', '6'],
    ['3', '3', '7', '7', '7', '7', '6'],
    ['3', '3', '7', '@', '@', '@', '@']],
  '4-21': [['6', '3', '3', '@', '1', '1', '@'],
    ['6', '3', '3', '8', '8', '1', '@'],
    ['6', '6', '3', '8', '8', '1', '1'],
    ['6', '2', '2', '8', '8', '5', '5'],
    ['4', '7', '2', '2', '2', '5', '@'],
    ['4', '7', '7', '7', '7', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '4-22': [['1', '1', '2', '@', '8', '8', '@'],
    ['4', '1', '2', '2', '8', '8', '@'],
    ['4', '1', '1', '2', '8', '8', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['@', '3', '3', '7', '5', '5', '6'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '4-23': [['1', '1', '2', '@', '8', '8', '@'],
    ['4', '1', '2', '2', '8', '8', '@'],
    ['4', '1', '1', '2', '8', '8', '6'],
    ['4', '4', '4', '2', '3', '6', '6'],
    ['7', '7', '7', '7', '3', '3', '6'],
    ['5', '@', '5', '7', '3', '3', '6'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '4-24': [['1', '1', '2', '@', '8', '8', '@'],
    ['4', '1', '2', '2', '8', '8', '@'],
    ['4', '1', '1', '2', '8', '8', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['3', '3', '@', '7', '5', '5', '6'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '4-25': [['1', '1', '2', '@', '7', '7', '@'],
    ['4', '1', '2', '2', '7', '3', '@'],
    ['4', '1', '1', '2', '7', '3', '3'],
    ['4', '4', '4', '2', '7', '3', '3'],
    ['6', '6', '6', '6', '8', '8', '8'],
    ['5', '6', '5', '@', '8', '8', '8'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '4-26': [['1', '1', '5', '@', '5', '4', '@'],
    ['2', '1', '5', '5', '5', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '7'],
    ['2', '2', '6', '8', '8', '8', '7'],
    ['3', '2', '6', '8', '8', '8', '7'],
    ['3', '3', '6', '6', '@', '7', '7'],
    ['3', '3', '6', '@', '@', '@', '@']],
  '4-27': [['3', '3', '1', '@', '7', '7', '@'],
    ['3', '3', '1', '1', '1', '7', '@'],
    ['5', '3', '5', '2', '1', '7', '6'],
    ['5', '5', '5', '2', '2', '7', '6'],
    ['4', '8', '8', '8', '2', '6', '6'],
    ['4', '8', '8', '8', '2', '@', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '4-28': [['4', '4', '4', '@', '1', '1', '@'],
    ['7', '7', '4', '8', '8', '1', '@'],
    ['7', '6', '4', '8', '8', '1', '1'],
    ['7', '6', '6', '8', '8', '3', '3'],
    ['7', '6', '2', '2', '3', '3', '3'],
    ['5', '6', '5', '2', '2', '2', '@'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '4-29': [['1', '1', '2', '@', '8', '8', '@'],
    ['4', '1', '2', '2', '8', '8', '@'],
    ['4', '1', '1', '2', '8', '8', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['7', '3', '3', '3', '5', '5', '6'],
    ['@', '3', '3', '@', '@', '@', '@']],
  '4-3': [['3', '3', '5', '@', '5', '6', '@'],
    ['3', '3', '5', '5', '5', '6', '@'],
    ['7', '3', '@', '1', '1', '6', '6'],
    ['7', '8', '8', '8', '1', '6', '4'],
    ['7', '8', '8', '8', '1', '1', '4'],
    ['7', '7', '2', '2', '4', '4', '4'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '4-30': [['1', '1', '2', '@', '8', '8', '@'],
    ['4', '1', '2', '2', '8', '8', '@'],
    ['4', '1', '1', '2', '8', '8', '6'],
    ['4', '4', '4', '2', '3', '6', '6'],
    ['7', '7', '7', '7', '3', '3', '6'],
    ['5', '5', '5', '7', '3', '3', '6'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '4-31': [['1', '1', '2', '@', '8', '8', '@'],
    ['4', '1', '2', '2', '8', '8', '@'],
    ['4', '1', '1', '2', '8', '8', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['3', '3', '3', '7', '5', '5', '6'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '4-4': [['1', '1', '5', '@', '5', '6', '@'],
    ['4', '1', '5', '5', '5', '6', '@'],
    ['4', '1', '1', '@', '7', '6', '6'],
    ['4', '4', '4', '2', '7', '6', '3'],
    ['8', '8', '2', '2', '7', '3', '3'],
    ['8', '8', '2', '7', '7', '3', '3'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '4-5': [['1', '1', '2', '@', '3', '3', '@'],
    ['4', '1', '2', '2', '3', '3', '@'],
    ['4', '1', '1', '2', '@', '3', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['8', '8', '8', '7', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-6': [['1', '1', '2', '@', '3', '3', '@'],
    ['4', '1', '2', '2', '3', '3', '@'],
    ['4', '1', '1', '2', '3', '@', '6'],
    ['4', '4', '4', '2', '5', '5', '6'],
    ['7', '7', '7', '7', '5', '6', '6'],
    ['8', '8', '8', '7', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-7': [['1', '1', '2', '@', '3', '3', '@'],
    ['4', '1', '2', '2', '3', '3', '@'],
    ['4', '1', '1', '2', '6', '3', '@'],
    ['4', '4', '4', '2', '6', '5', '5'],
    ['7', '7', '7', '7', '6', '6', '5'],
    ['8', '8', '8', '7', '6', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '4-8': [['4', '4', '4', '@', '1', '1', '@'],
    ['3', '3', '4', '8', '8', '1', '@'],
    ['3', '3', '4', '8', '8', '1', '1'],
    ['@', '3', '6', '8', '8', '2', '2'],
    ['5', '5', '6', '2', '2', '2', '7'],
    ['5', '6', '6', '7', '7', '7', '7'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '4-9': [['3', '3', '6', '@', '1', '1', '@'],
    ['3', '3', '6', '5', '5', '1', '@'],
    ['4', '3', '6', '6', '5', '1', '1'],
    ['4', '@', '6', '5', '5', '2', '2'],
    ['4', '4', '4', '2', '2', '2', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-1': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['@', '2', '1', '1', '6', '7', '7'],
    ['3', '2', '6', '6', '6', '6', '7'],
    ['3', '3', '4', '8', '8', '8', '7'],
    ['3', '3', '4', '8', '8', '8', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '5-10': [['3', '3', '4', '5', '@', '5', '@'],
    ['3', '3', '4', '5', '5', '5', '@'],
    ['6', '3', '4', '4', '4', '7', '7'],
    ['6', '6', '@', '1', '8', '8', '7'],
    ['6', '1', '1', '1', '8', '8', '7'],
    ['6', '1', '2', '2', '8', '8', '7'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '5-11': [['2', '3', '3', '3', '@', '6', '@'],
    ['2', '2', '3', '3', '1', '6', '@'],
    ['4', '2', '1', '1', '1', '6', '6'],
    ['4', '2', '1', '@', '5', '6', '5'],
    ['4', '4', '4', '7', '5', '5', '5'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-12': [['6', '6', '6', '6', '@', '2', '@'],
    ['1', '1', '6', '3', '3', '2', '@'],
    ['4', '1', '3', '3', '3', '2', '2'],
    ['4', '1', '1', '5', '@', '5', '2'],
    ['4', '4', '4', '5', '5', '5', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-13': [['1', '1', '3', '3', '@', '2', '@'],
    ['4', '1', '3', '3', '2', '2', '@'],
    ['4', '1', '1', '3', '2', '5', '5'],
    ['4', '4', '4', '7', '2', '@', '5'],
    ['7', '7', '7', '7', '6', '5', '5'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-14': [['1', '1', '3', '3', '@', '2', '@'],
    ['4', '1', '3', '3', '2', '2', '@'],
    ['4', '1', '1', '3', '2', '5', '5'],
    ['4', '4', '4', '7', '2', '5', '@'],
    ['7', '7', '7', '7', '6', '5', '5'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-15': [['3', '3', '8', '8', '@', '6', '@'],
    ['3', '3', '8', '8', '6', '6', '@'],
    ['2', '3', '8', '8', '1', '6', '4'],
    ['2', '2', '1', '1', '1', '6', '4'],
    ['@', '2', '1', '7', '4', '4', '4'],
    ['5', '2', '5', '7', '7', '7', '7'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '5-16': [['3', '3', '2', '5', '@', '5', '@'],
    ['3', '3', '2', '5', '5', '5', '@'],
    ['1', '3', '2', '2', '8', '8', '7'],
    ['1', '1', '1', '2', '8', '8', '7'],
    ['4', '@', '1', '6', '8', '8', '7'],
    ['4', '6', '6', '6', '6', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '5-17': [['4', '4', '4', '7', '@', '3', '@'],
    ['1', '1', '4', '7', '3', '3', '@'],
    ['2', '1', '4', '7', '3', '3', '6'],
    ['2', '1', '1', '7', '7', '6', '6'],
    ['2', '2', '@', '8', '8', '8', '6'],
    ['5', '2', '5', '8', '8', '8', '6'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '5-18': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '@', '3', '3', '7'],
    ['8', '8', '8', '3', '3', '3', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-19': [['4', '4', '4', '5', '@', '5', '@'],
    ['7', '7', '4', '5', '5', '5', '@'],
    ['7', '2', '4', '6', '6', '6', '6'],
    ['7', '2', '1', '1', '6', '8', '8'],
    ['7', '2', '2', '1', '@', '8', '8'],
    ['3', '3', '2', '1', '1', '8', '8'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '5-2': [['3', '3', '5', '5', '@', '6', '@'],
    ['3', '3', '3', '5', '7', '6', '@'],
    ['1', '@', '5', '5', '7', '6', '6'],
    ['1', '1', '1', '2', '7', '6', '4'],
    ['8', '8', '1', '2', '7', '7', '4'],
    ['8', '8', '2', '2', '4', '4', '4'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '5-20': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '3', '3', '@', '7'],
    ['8', '8', '8', '3', '3', '3', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-21': [['3', '3', '5', '5', '@', '2', '@'],
    ['3', '3', '5', '1', '1', '2', '@'],
    ['7', '3', '5', '5', '1', '2', '2'],
    ['7', '7', '7', '7', '1', '1', '2'],
    ['8', '8', '4', '4', '4', '6', '@'],
    ['8', '8', '4', '6', '6', '6', '6'],
    ['8', '8', '4', '@', '@', '@', '@']],
  '5-22': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['@', '3', '3', '8', '8', '8', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '5-23': [['1', '1', '3', '3', '@', '2', '@'],
    ['4', '1', '3', '3', '2', '2', '@'],
    ['4', '1', '1', '3', '2', '8', '8'],
    ['4', '4', '4', '7', '2', '8', '8'],
    ['7', '7', '7', '7', '6', '8', '8'],
    ['5', '@', '5', '6', '6', '6', '6'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '5-24': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '3', '@', '8', '8', '8', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '5-25': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '3', '3', '3', '7'],
    ['8', '8', '8', '@', '3', '3', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-26': [['4', '4', '4', '5', '@', '5', '@'],
    ['8', '8', '4', '5', '5', '5', '@'],
    ['8', '8', '4', '6', '2', '7', '7'],
    ['8', '8', '1', '6', '2', '2', '7'],
    ['1', '1', '1', '6', '6', '2', '7'],
    ['1', '3', '3', '6', '@', '2', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '5-27': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '3', '3', '3', '7'],
    ['8', '8', '8', '3', '3', '@', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-28': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['6', '2', '1', '1', '4', '4', '4'],
    ['6', '2', '7', '7', '7', '7', '4'],
    ['6', '6', '7', '8', '8', '8', '4'],
    ['6', '3', '3', '8', '8', '8', '@'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '5-29': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '3', '3', '8', '8', '8', '7'],
    ['@', '3', '3', '@', '@', '@', '@']],
  '5-3': [['6', '6', '6', '6', '@', '2', '@'],
    ['1', '1', '6', '3', '3', '2', '@'],
    ['4', '1', '@', '3', '3', '2', '2'],
    ['4', '1', '1', '5', '3', '5', '2'],
    ['4', '4', '4', '5', '5', '5', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-30': [['1', '1', '3', '3', '@', '2', '@'],
    ['4', '1', '3', '3', '2', '2', '@'],
    ['4', '1', '1', '3', '2', '8', '8'],
    ['4', '4', '4', '7', '2', '8', '8'],
    ['7', '7', '7', '7', '6', '8', '8'],
    ['5', '5', '5', '6', '6', '6', '6'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '5-31': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '3', '3', '8', '8', '8', '7'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '5-4': [['4', '4', '4', '5', '@', '5', '@'],
    ['1', '1', '4', '5', '5', '5', '@'],
    ['7', '1', '4', '@', '8', '8', '8'],
    ['7', '1', '1', '6', '8', '8', '8'],
    ['7', '6', '6', '6', '6', '3', '3'],
    ['7', '7', '2', '2', '3', '3', '3'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '5-5': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['6', '2', '1', '1', '@', '7', '7'],
    ['6', '2', '8', '8', '8', '4', '7'],
    ['6', '6', '8', '8', '8', '4', '7'],
    ['6', '3', '3', '4', '4', '4', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '5-6': [['2', '1', '1', '5', '@', '5', '@'],
    ['2', '2', '1', '5', '5', '5', '@'],
    ['4', '2', '1', '1', '6', '@', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '3', '3', '3', '7'],
    ['8', '8', '8', '3', '3', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '5-7': [['3', '3', '1', '1', '@', '6', '@'],
    ['3', '3', '3', '1', '6', '6', '@'],
    ['2', '2', '2', '1', '1', '6', '@'],
    ['8', '8', '2', '2', '5', '6', '5'],
    ['8', '8', '4', '7', '5', '5', '5'],
    ['8', '8', '4', '7', '7', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '5-8': [['6', '6', '6', '6', '@', '1', '@'],
    ['3', '3', '6', '1', '1', '1', '@'],
    ['3', '3', '5', '1', '5', '2', '7'],
    ['@', '3', '5', '5', '5', '2', '7'],
    ['4', '8', '8', '8', '2', '2', '7'],
    ['4', '8', '8', '8', '2', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '5-9': [['3', '3', '8', '8', '@', '6', '@'],
    ['3', '3', '8', '8', '6', '6', '@'],
    ['2', '3', '8', '8', '1', '6', '4'],
    ['2', '@', '1', '1', '1', '6', '4'],
    ['2', '2', '1', '7', '4', '4', '4'],
    ['5', '2', '5', '7', '7', '7', '7'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '6-1': [['2', '7', '7', '8', '8', '@', '@'],
    ['2', '2', '7', '8', '8', '3', '@'],
    ['@', '2', '7', '8', '8', '3', '3'],
    ['6', '2', '7', '4', '1', '3', '3'],
    ['6', '5', '5', '4', '1', '1', '1'],
    ['6', '6', '5', '4', '4', '4', '1'],
    ['6', '5', '5', '@', '@', '@', '@']],
  '6-10': [['2', '2', '4', '4', '4', '@', '@'],
    ['3', '2', '2', '2', '4', '6', '@'],
    ['3', '3', '5', '5', '4', '6', '7'],
    ['3', '3', '@', '5', '6', '6', '7'],
    ['8', '8', '5', '5', '1', '6', '7'],
    ['8', '8', '1', '1', '1', '7', '7'],
    ['8', '8', '1', '@', '@', '@', '@']],
  '6-11': [['2', '2', '4', '4', '4', '@', '@'],
    ['3', '2', '2', '2', '4', '6', '@'],
    ['3', '3', '5', '5', '4', '6', '7'],
    ['3', '3', '5', '@', '6', '6', '7'],
    ['8', '8', '5', '5', '1', '6', '7'],
    ['8', '8', '1', '1', '1', '7', '7'],
    ['8', '8', '1', '@', '@', '@', '@']],
  '6-12': [['1', '1', '8', '8', '8', '@', '@'],
    ['4', '1', '8', '8', '8', '6', '@'],
    ['4', '1', '1', '6', '6', '6', '6'],
    ['4', '4', '4', '7', '@', '5', '5'],
    ['7', '7', '7', '7', '2', '2', '5'],
    ['3', '3', '2', '2', '2', '5', '5'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '6-13': [['2', '6', '6', '6', '6', '@', '@'],
    ['2', '2', '6', '3', '3', '3', '@'],
    ['4', '2', '1', '3', '3', '5', '5'],
    ['4', '2', '1', '1', '1', '@', '5'],
    ['4', '4', '4', '7', '1', '5', '5'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-14': [['1', '1', '2', '7', '7', '@', '@'],
    ['4', '1', '2', '2', '7', '6', '@'],
    ['4', '1', '1', '2', '7', '6', '6'],
    ['4', '4', '4', '2', '7', '6', '@'],
    ['8', '8', '3', '3', '5', '6', '5'],
    ['8', '8', '3', '3', '5', '5', '5'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '6-15': [['1', '1', '4', '4', '4', '@', '@'],
    ['2', '1', '5', '5', '4', '6', '@'],
    ['2', '1', '1', '5', '4', '6', '7'],
    ['2', '2', '5', '5', '6', '6', '7'],
    ['@', '2', '8', '8', '8', '6', '7'],
    ['3', '3', '8', '8', '8', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '6-16': [['1', '1', '2', '2', '2', '@', '@'],
    ['6', '1', '5', '5', '2', '2', '@'],
    ['6', '1', '1', '5', '4', '3', '3'],
    ['6', '6', '5', '5', '4', '3', '3'],
    ['6', '@', '4', '4', '4', '3', '7'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-17': [['1', '1', '8', '8', '8', '@', '@'],
    ['4', '1', '8', '8', '8', '6', '@'],
    ['4', '1', '1', '5', '5', '6', '7'],
    ['4', '4', '4', '5', '6', '6', '7'],
    ['3', '3', '@', '5', '5', '6', '7'],
    ['3', '3', '2', '2', '2', '7', '7'],
    ['3', '2', '2', '@', '@', '@', '@']],
  '6-18': [['2', '7', '7', '7', '7', '@', '@'],
    ['2', '2', '5', '5', '7', '6', '@'],
    ['4', '2', '5', '6', '6', '6', '6'],
    ['4', '2', '5', '5', '1', '1', '3'],
    ['4', '4', '4', '@', '1', '3', '3'],
    ['8', '8', '8', '1', '1', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-19': [['1', '1', '5', '5', '5', '@', '@'],
    ['7', '1', '5', '4', '5', '3', '@'],
    ['7', '1', '1', '4', '3', '3', '6'],
    ['7', '4', '4', '4', '3', '3', '6'],
    ['7', '7', '2', '2', '@', '6', '6'],
    ['8', '8', '8', '2', '2', '2', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-2': [['3', '3', '5', '5', '6', '@', '@'],
    ['3', '3', '3', '5', '6', '6', '@'],
    ['7', '@', '5', '5', '6', '1', '1'],
    ['7', '8', '8', '8', '6', '1', '4'],
    ['7', '8', '8', '8', '1', '1', '4'],
    ['7', '7', '2', '2', '4', '4', '4'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '6-20': [['1', '1', '2', '2', '2', '@', '@'],
    ['6', '1', '5', '5', '2', '2', '@'],
    ['6', '1', '1', '5', '8', '8', '8'],
    ['6', '6', '5', '5', '8', '8', '8'],
    ['6', '3', '4', '4', '4', '@', '7'],
    ['3', '3', '4', '7', '7', '7', '7'],
    ['3', '3', '4', '@', '@', '@', '@']],
  '6-21': [['1', '1', '5', '5', '5', '@', '@'],
    ['4', '1', '5', '2', '5', '3', '@'],
    ['4', '1', '1', '2', '2', '3', '3'],
    ['4', '4', '4', '7', '2', '3', '3'],
    ['7', '7', '7', '7', '2', '6', '@'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-22': [['1', '1', '8', '8', '8', '@', '@'],
    ['4', '1', '8', '8', '8', '6', '@'],
    ['4', '1', '1', '6', '6', '6', '6'],
    ['4', '4', '4', '2', '3', '3', '3'],
    ['5', '5', '2', '2', '3', '3', '7'],
    ['@', '5', '2', '7', '7', '7', '7'],
    ['5', '5', '2', '@', '@', '@', '@']],
  '6-23': [['1', '1', '8', '8', '8', '@', '@'],
    ['4', '1', '8', '8', '8', '6', '@'],
    ['4', '1', '1', '6', '6', '6', '6'],
    ['4', '4', '4', '2', '3', '3', '3'],
    ['5', '5', '2', '2', '3', '3', '7'],
    ['5', '@', '2', '7', '7', '7', '7'],
    ['5', '5', '2', '@', '@', '@', '@']],
  '6-24': [['2', '2', '4', '4', '4', '@', '@'],
    ['1', '2', '2', '2', '4', '3', '@'],
    ['1', '1', '1', '6', '4', '3', '3'],
    ['7', '7', '1', '6', '6', '3', '3'],
    ['7', '5', '5', '6', '8', '8', '8'],
    ['7', '5', '@', '6', '8', '8', '8'],
    ['7', '5', '5', '@', '@', '@', '@']],
  '6-25': [['1', '1', '2', '7', '7', '@', '@'],
    ['4', '1', '2', '2', '7', '3', '@'],
    ['4', '1', '1', '2', '7', '3', '3'],
    ['4', '4', '4', '2', '7', '3', '3'],
    ['6', '6', '6', '6', '8', '8', '8'],
    ['5', '6', '5', '@', '8', '8', '8'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '6-26': [['1', '1', '5', '5', '5', '@', '@'],
    ['4', '1', '5', '2', '5', '6', '@'],
    ['4', '1', '1', '2', '6', '6', '7'],
    ['4', '4', '4', '2', '2', '6', '7'],
    ['8', '8', '3', '3', '2', '6', '7'],
    ['8', '8', '3', '3', '@', '7', '7'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '6-27': [['1', '1', '8', '8', '8', '@', '@'],
    ['4', '1', '8', '8', '8', '6', '@'],
    ['4', '1', '1', '6', '6', '6', '6'],
    ['4', '4', '4', '7', '7', '7', '7'],
    ['2', '2', '2', '7', '5', '5', '5'],
    ['3', '3', '2', '2', '5', '@', '5'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '6-28': [['1', '1', '4', '4', '4', '@', '@'],
    ['6', '1', '5', '5', '4', '3', '@'],
    ['6', '1', '1', '5', '4', '3', '3'],
    ['6', '6', '5', '5', '7', '3', '3'],
    ['6', '7', '7', '7', '7', '2', '2'],
    ['8', '8', '8', '2', '2', '2', '@'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-29': [['1', '1', '8', '8', '8', '@', '@'],
    ['4', '1', '8', '8', '8', '6', '@'],
    ['4', '1', '1', '5', '5', '6', '7'],
    ['4', '4', '4', '5', '6', '6', '7'],
    ['3', '3', '3', '5', '5', '6', '7'],
    ['3', '3', '2', '2', '2', '7', '7'],
    ['@', '2', '2', '@', '@', '@', '@']],
  '6-3': [['2', '6', '6', '6', '6', '@', '@'],
    ['2', '2', '6', '5', '5', '5', '@'],
    ['4', '2', '@', '5', '3', '5', '7'],
    ['4', '2', '1', '1', '3', '3', '7'],
    ['4', '4', '4', '1', '3', '3', '7'],
    ['8', '8', '8', '1', '1', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-30': [['2', '1', '1', '3', '3', '@', '@'],
    ['2', '2', '1', '3', '3', '3', '@'],
    ['4', '2', '1', '1', '6', '7', '7'],
    ['4', '2', '6', '6', '6', '6', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['5', '5', '5', '8', '8', '8', '7'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '6-31': [['1', '1', '4', '4', '4', '@', '@'],
    ['2', '1', '5', '5', '4', '6', '@'],
    ['2', '1', '1', '5', '4', '6', '7'],
    ['2', '2', '5', '5', '6', '6', '7'],
    ['3', '2', '8', '8', '8', '6', '7'],
    ['3', '3', '8', '8', '8', '7', '7'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '6-4': [['3', '3', '8', '8', '8', '@', '@'],
    ['3', '3', '8', '8', '8', '2', '@'],
    ['5', '3', '5', '@', '2', '2', '6'],
    ['5', '5', '5', '1', '2', '6', '6'],
    ['4', '1', '1', '1', '2', '7', '6'],
    ['4', '1', '7', '7', '7', '7', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '6-5': [['2', '1', '1', '3', '3', '@', '@'],
    ['2', '2', '1', '3', '3', '3', '@'],
    ['4', '2', '1', '1', '@', '5', '5'],
    ['4', '2', '6', '6', '6', '6', '5'],
    ['4', '4', '4', '7', '6', '5', '5'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-6': [['3', '3', '2', '2', '2', '@', '@'],
    ['3', '3', '1', '1', '2', '2', '@'],
    ['4', '3', '1', '7', '7', '@', '6'],
    ['4', '1', '1', '7', '5', '5', '6'],
    ['4', '4', '4', '7', '5', '6', '6'],
    ['8', '8', '8', '7', '5', '5', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-7': [['1', '1', '2', '7', '7', '@', '@'],
    ['4', '1', '2', '2', '7', '6', '@'],
    ['4', '1', '1', '2', '7', '6', '@'],
    ['4', '4', '4', '2', '7', '6', '6'],
    ['8', '8', '3', '3', '5', '6', '5'],
    ['8', '8', '3', '3', '5', '5', '5'],
    ['8', '8', '3', '@', '@', '@', '@']],
  '6-8': [['3', '3', '5', '5', '6', '@', '@'],
    ['3', '3', '3', '5', '6', '6', '@'],
    ['2', '2', '5', '5', '6', '1', '1'],
    ['@', '2', '2', '2', '6', '1', '4'],
    ['7', '7', '7', '7', '1', '1', '4'],
    ['8', '8', '8', '7', '4', '4', '4'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '6-9': [['1', '1', '2', '2', '2', '@', '@'],
    ['7', '1', '5', '5', '2', '2', '@'],
    ['7', '1', '1', '5', '4', '3', '3'],
    ['7', '@', '5', '5', '4', '3', '3'],
    ['7', '7', '4', '4', '4', '6', '3'],
    ['8', '8', '8', '6', '6', '6', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '7-1': [['1', '1', '3', '3', '7', '2', '@'],
    ['@', '1', '3', '3', '7', '2', '@'],
    ['@', '1', '1', '3', '7', '2', '2'],
    ['6', '6', '6', '6', '7', '7', '2'],
    ['4', '5', '6', '5', '8', '8', '8'],
    ['4', '5', '5', '5', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-10': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '6', '3', '3', '@'],
    ['2', '1', '1', '6', '3', '3', '3'],
    ['2', '2', '@', '6', '6', '8', '8'],
    ['4', '2', '5', '6', '5', '8', '8'],
    ['4', '2', '5', '5', '5', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-11': [['1', '1', '3', '3', '8', '8', '@'],
    ['@', '1', '3', '3', '8', '8', '@'],
    ['2', '1', '1', '3', '8', '8', '6'],
    ['2', '2', '5', '@', '5', '6', '6'],
    ['4', '2', '5', '5', '5', '7', '6'],
    ['4', '2', '7', '7', '7', '7', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-12': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '6', '3', '3', '@'],
    ['2', '1', '1', '6', '3', '3', '3'],
    ['2', '2', '6', '6', '@', '8', '8'],
    ['4', '2', '5', '6', '5', '8', '8'],
    ['4', '2', '5', '5', '5', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-13': [['1', '1', '3', '3', '8', '8', '@'],
    ['@', '1', '3', '3', '8', '8', '@'],
    ['2', '1', '1', '3', '8', '8', '4'],
    ['2', '6', '6', '6', '6', '@', '4'],
    ['2', '2', '6', '7', '4', '4', '4'],
    ['5', '2', '5', '7', '7', '7', '7'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '7-14': [['1', '1', '3', '3', '7', '7', '@'],
    ['@', '1', '3', '3', '7', '6', '@'],
    ['2', '1', '1', '3', '7', '6', '6'],
    ['2', '2', '8', '8', '7', '6', '@'],
    ['4', '2', '8', '8', '5', '6', '5'],
    ['4', '2', '8', '8', '5', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-15': [['1', '1', '8', '8', '8', '4', '@'],
    ['@', '1', '8', '8', '8', '4', '@'],
    ['2', '1', '1', '4', '4', '4', '6'],
    ['2', '2', '7', '7', '7', '7', '6'],
    ['@', '2', '7', '3', '3', '6', '6'],
    ['5', '2', '5', '3', '3', '3', '6'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '7-16': [['1', '1', '8', '8', '8', '4', '@'],
    ['@', '1', '8', '8', '8', '4', '@'],
    ['7', '1', '1', '4', '4', '4', '6'],
    ['7', '3', '3', '3', '5', '5', '6'],
    ['7', '@', '3', '3', '5', '6', '6'],
    ['7', '7', '2', '2', '5', '5', '6'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '7-17': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '4', '8', '8', '@'],
    ['2', '1', '1', '4', '8', '8', '6'],
    ['2', '4', '4', '4', '8', '8', '6'],
    ['2', '2', '@', '3', '3', '6', '6'],
    ['5', '2', '5', '3', '3', '3', '6'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '7-18': [['1', '1', '3', '3', '8', '8', '@'],
    ['@', '1', '3', '3', '8', '8', '@'],
    ['2', '1', '1', '3', '8', '8', '6'],
    ['2', '2', '5', '5', '5', '6', '6'],
    ['4', '2', '5', '@', '5', '7', '6'],
    ['4', '2', '7', '7', '7', '7', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-19': [['1', '1', '4', '4', '4', '7', '@'],
    ['@', '1', '5', '5', '4', '7', '@'],
    ['3', '1', '1', '5', '4', '7', '6'],
    ['3', '3', '5', '5', '7', '7', '6'],
    ['3', '3', '2', '2', '@', '6', '6'],
    ['8', '8', '8', '2', '2', '2', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '7-2': [['2', '2', '6', '6', '6', '6', '@'],
    ['@', '2', '2', '2', '6', '1', '@'],
    ['5', '@', '5', '1', '1', '1', '3'],
    ['5', '5', '5', '1', '4', '3', '3'],
    ['7', '7', '7', '7', '4', '3', '3'],
    ['8', '8', '8', '7', '4', '4', '4'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '7-20': [['1', '1', '3', '3', '8', '8', '@'],
    ['@', '1', '3', '3', '8', '8', '@'],
    ['2', '1', '1', '3', '8', '8', '7'],
    ['2', '2', '6', '6', '6', '6', '7'],
    ['4', '2', '5', '6', '5', '@', '7'],
    ['4', '2', '5', '5', '5', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-21': [['2', '2', '7', '7', '7', '7', '@'],
    ['@', '2', '2', '2', '1', '7', '@'],
    ['6', '6', '6', '6', '1', '1', '1'],
    ['5', '6', '5', '4', '4', '4', '1'],
    ['5', '5', '5', '4', '3', '3', '@'],
    ['8', '8', '8', '4', '3', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '7-22': [['1', '1', '3', '3', '8', '8', '@'],
    ['@', '1', '3', '3', '8', '8', '@'],
    ['2', '1', '1', '3', '8', '8', '6'],
    ['2', '7', '7', '7', '7', '6', '6'],
    ['2', '2', '4', '5', '7', '5', '6'],
    ['@', '2', '4', '5', '5', '5', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-23': [['1', '1', '8', '8', '8', '6', '@'],
    ['@', '1', '8', '8', '8', '6', '@'],
    ['7', '1', '1', '5', '5', '6', '6'],
    ['7', '7', '7', '7', '5', '6', '3'],
    ['4', '4', '4', '5', '5', '3', '3'],
    ['4', '@', '2', '2', '2', '3', '3'],
    ['4', '2', '2', '@', '@', '@', '@']],
  '7-24': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '8', '8', '8', '@'],
    ['2', '1', '1', '8', '8', '8', '6'],
    ['2', '2', '3', '3', '5', '5', '6'],
    ['4', '2', '3', '3', '5', '6', '6'],
    ['4', '2', '@', '3', '5', '5', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-25': [['1', '1', '4', '4', '4', '7', '@'],
    ['@', '1', '5', '5', '4', '7', '@'],
    ['3', '1', '1', '5', '4', '7', '6'],
    ['3', '3', '5', '5', '7', '7', '6'],
    ['3', '3', '2', '2', '2', '6', '6'],
    ['8', '8', '8', '@', '2', '2', '6'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '7-26': [['1', '1', '5', '5', '5', '6', '@'],
    ['@', '1', '5', '2', '5', '6', '@'],
    ['7', '1', '1', '2', '2', '6', '6'],
    ['7', '7', '7', '7', '2', '6', '3'],
    ['4', '8', '8', '8', '2', '3', '3'],
    ['4', '8', '8', '8', '@', '3', '3'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-27': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '4', '8', '8', '@'],
    ['2', '1', '1', '4', '8', '8', '6'],
    ['2', '4', '4', '4', '8', '8', '6'],
    ['2', '2', '3', '3', '3', '6', '6'],
    ['5', '2', '5', '3', '3', '@', '6'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '7-28': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '3', '3', '3', '@'],
    ['2', '1', '1', '3', '3', '8', '8'],
    ['2', '2', '5', '5', '5', '8', '8'],
    ['4', '2', '5', '6', '5', '8', '8'],
    ['4', '2', '6', '6', '6', '6', '@'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-29': [['1', '1', '4', '4', '4', '2', '@'],
    ['@', '1', '5', '5', '4', '2', '@'],
    ['6', '1', '1', '5', '4', '2', '2'],
    ['6', '6', '5', '5', '3', '3', '2'],
    ['6', '8', '8', '3', '3', '3', '7'],
    ['6', '8', '8', '7', '7', '7', '7'],
    ['@', '8', '8', '@', '@', '@', '@']],
  '7-3': [['2', '2', '7', '7', '7', '7', '@'],
    ['@', '2', '2', '2', '6', '7', '@'],
    ['5', '5', '@', '6', '6', '6', '6'],
    ['5', '1', '1', '8', '8', '8', '4'],
    ['5', '5', '1', '8', '8', '8', '4'],
    ['3', '3', '1', '1', '4', '4', '4'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '7-30': [['1', '1', '8', '8', '8', '2', '@'],
    ['@', '1', '8', '8', '8', '2', '@'],
    ['7', '1', '1', '5', '5', '2', '2'],
    ['7', '7', '7', '7', '5', '3', '2'],
    ['4', '4', '4', '5', '5', '3', '3'],
    ['4', '6', '6', '6', '6', '3', '3'],
    ['4', '@', '6', '@', '@', '@', '@']],
  '7-31': [['1', '1', '8', '8', '8', '6', '@'],
    ['@', '1', '8', '8', '8', '6', '@'],
    ['4', '1', '1', '2', '2', '6', '6'],
    ['4', '2', '2', '2', '5', '6', '5'],
    ['4', '4', '4', '7', '5', '5', '5'],
    ['3', '3', '3', '7', '7', '7', '7'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '7-4': [['1', '1', '3', '3', '5', '5', '@'],
    ['@', '1', '3', '3', '3', '5', '@'],
    ['2', '1', '1', '@', '5', '5', '6'],
    ['2', '2', '8', '8', '8', '6', '6'],
    ['4', '2', '8', '8', '8', '7', '6'],
    ['4', '2', '7', '7', '7', '7', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-5': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '5', '5', '5', '@'],
    ['2', '1', '1', '5', '@', '5', '6'],
    ['2', '2', '8', '8', '3', '6', '6'],
    ['4', '2', '8', '8', '3', '3', '6'],
    ['4', '2', '8', '8', '3', '3', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-6': [['1', '1', '7', '7', '7', '7', '@'],
    ['@', '1', '7', '3', '3', '3', '@'],
    ['2', '1', '1', '3', '3', '@', '6'],
    ['2', '2', '8', '8', '5', '5', '6'],
    ['4', '2', '8', '8', '5', '6', '6'],
    ['4', '2', '8', '8', '5', '5', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-7': [['1', '1', '3', '3', '7', '7', '@'],
    ['@', '1', '3', '3', '7', '6', '@'],
    ['2', '1', '1', '3', '7', '6', '@'],
    ['2', '2', '8', '8', '7', '6', '6'],
    ['4', '2', '8', '8', '5', '6', '5'],
    ['4', '2', '8', '8', '5', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-8': [['5', '5', '1', '1', '3', '3', '@'],
    ['@', '5', '2', '1', '3', '3', '@'],
    ['5', '5', '2', '1', '1', '3', '7'],
    ['@', '2', '2', '8', '8', '8', '7'],
    ['4', '2', '6', '8', '8', '8', '7'],
    ['4', '6', '6', '6', '6', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '7-9': [['1', '1', '6', '6', '6', '6', '@'],
    ['@', '1', '5', '5', '6', '2', '@'],
    ['4', '1', '1', '5', '2', '2', '3'],
    ['4', '@', '5', '5', '2', '3', '3'],
    ['4', '4', '4', '7', '2', '3', '3'],
    ['8', '8', '8', '7', '7', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '8-1': [['7', '7', '7', '7', '1', '1', '@'],
    ['7', '@', '4', '4', '4', '1', '@'],
    ['@', '2', '2', '2', '4', '1', '1'],
    ['2', '2', '3', '3', '4', '8', '8'],
    ['5', '5', '3', '3', '3', '8', '8'],
    ['5', '6', '6', '6', '6', '8', '8'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '8-10': [['4', '4', '4', '7', '7', '2', '@'],
    ['6', '@', '4', '7', '2', '2', '@'],
    ['6', '6', '4', '7', '2', '3', '3'],
    ['6', '1', '@', '7', '2', '3', '3'],
    ['6', '1', '1', '1', '5', '3', '5'],
    ['8', '8', '8', '1', '5', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '8-11': [['4', '4', '4', '3', '1', '1', '@'],
    ['2', '@', '4', '3', '3', '1', '@'],
    ['2', '2', '4', '3', '3', '1', '1'],
    ['7', '2', '5', '@', '5', '8', '8'],
    ['7', '2', '5', '5', '5', '8', '8'],
    ['7', '6', '6', '6', '6', '8', '8'],
    ['7', '7', '6', '@', '@', '@', '@']],
  '8-12': [['4', '4', '4', '5', '5', '5', '@'],
    ['6', '@', '4', '5', '2', '5', '@'],
    ['6', '6', '4', '1', '2', '2', '7'],
    ['6', '1', '1', '1', '@', '2', '7'],
    ['6', '1', '8', '8', '8', '2', '7'],
    ['3', '3', '8', '8', '8', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '8-13': [['4', '4', '4', '8', '8', '2', '@'],
    ['6', '@', '4', '8', '8', '2', '@'],
    ['6', '6', '4', '8', '8', '2', '2'],
    ['6', '5', '5', '5', '1', '@', '2'],
    ['6', '5', '7', '5', '1', '1', '1'],
    ['3', '3', '7', '7', '7', '7', '1'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '8-14': [['4', '4', '4', '3', '3', '6', '@'],
    ['7', '@', '4', '3', '3', '6', '@'],
    ['7', '5', '4', '5', '3', '6', '6'],
    ['7', '5', '5', '5', '1', '6', '@'],
    ['7', '7', '2', '2', '1', '1', '1'],
    ['8', '8', '8', '2', '2', '2', '1'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '8-15': [['6', '6', '6', '6', '8', '8', '@'],
    ['1', '@', '6', '2', '8', '8', '@'],
    ['1', '1', '1', '2', '8', '8', '3'],
    ['5', '5', '1', '2', '2', '3', '3'],
    ['@', '5', '4', '7', '2', '3', '3'],
    ['5', '5', '4', '7', '7', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '8-16': [['4', '4', '4', '5', '5', '5', '@'],
    ['6', '@', '4', '5', '2', '5', '@'],
    ['6', '6', '4', '2', '2', '7', '7'],
    ['6', '1', '1', '2', '8', '8', '7'],
    ['6', '@', '1', '2', '8', '8', '7'],
    ['3', '3', '1', '1', '8', '8', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '8-17': [['4', '4', '4', '5', '5', '5', '@'],
    ['6', '@', '4', '5', '2', '5', '@'],
    ['6', '6', '4', '1', '2', '2', '7'],
    ['6', '1', '1', '1', '3', '2', '7'],
    ['6', '1', '@', '3', '3', '2', '7'],
    ['8', '8', '8', '3', '3', '7', '7'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '8-18': [['4', '4', '4', '3', '1', '1', '@'],
    ['2', '@', '4', '3', '3', '1', '@'],
    ['2', '2', '4', '3', '3', '1', '1'],
    ['6', '2', '7', '5', '5', '8', '8'],
    ['6', '2', '7', '@', '5', '8', '8'],
    ['6', '6', '7', '5', '5', '8', '8'],
    ['6', '7', '7', '@', '@', '@', '@']],
  '8-19': [['4', '4', '4', '2', '1', '1', '@'],
    ['3', '@', '4', '2', '2', '1', '@'],
    ['3', '3', '4', '7', '2', '1', '1'],
    ['3', '3', '6', '7', '2', '8', '8'],
    ['5', '5', '6', '7', '@', '8', '8'],
    ['5', '6', '6', '7', '7', '8', '8'],
    ['5', '5', '6', '@', '@', '@', '@']],
  '8-2': [['6', '6', '6', '6', '1', '1', '@'],
    ['2', '@', '6', '8', '8', '1', '@'],
    ['2', '@', '7', '8', '8', '1', '1'],
    ['2', '2', '7', '8', '8', '5', '5'],
    ['4', '2', '7', '3', '3', '3', '5'],
    ['4', '7', '7', '3', '3', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '8-20': [['4', '4', '4', '3', '1', '1', '@'],
    ['2', '@', '4', '3', '3', '1', '@'],
    ['2', '2', '4', '3', '3', '1', '1'],
    ['6', '2', '7', '8', '8', '5', '5'],
    ['6', '2', '7', '8', '8', '@', '5'],
    ['6', '6', '7', '8', '8', '5', '5'],
    ['6', '7', '7', '@', '@', '@', '@']],
  '8-21': [['4', '4', '4', '3', '1', '1', '@'],
    ['2', '@', '4', '3', '3', '1', '@'],
    ['2', '2', '4', '3', '3', '1', '1'],
    ['6', '2', '7', '8', '8', '5', '5'],
    ['6', '2', '7', '8', '8', '5', '@'],
    ['6', '6', '7', '8', '8', '5', '5'],
    ['6', '7', '7', '@', '@', '@', '@']],
  '8-22': [['4', '4', '4', '8', '8', '2', '@'],
    ['6', '@', '4', '8', '8', '2', '@'],
    ['6', '6', '4', '8', '8', '2', '2'],
    ['6', '1', '7', '7', '7', '7', '2'],
    ['6', '1', '1', '1', '5', '7', '5'],
    ['@', '3', '3', '1', '5', '5', '5'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '8-23': [['4', '4', '4', '3', '1', '1', '@'],
    ['2', '@', '4', '3', '3', '1', '@'],
    ['2', '2', '4', '3', '3', '1', '1'],
    ['7', '2', '6', '5', '5', '8', '8'],
    ['7', '2', '6', '6', '5', '8', '8'],
    ['7', '@', '6', '5', '5', '8', '8'],
    ['7', '7', '6', '@', '@', '@', '@']],
  '8-24': [['4', '4', '4', '8', '8', '2', '@'],
    ['6', '@', '4', '8', '8', '2', '@'],
    ['6', '6', '4', '8', '8', '2', '2'],
    ['6', '1', '7', '7', '7', '7', '2'],
    ['6', '1', '1', '1', '5', '7', '5'],
    ['3', '3', '@', '1', '5', '5', '5'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '8-25': [['4', '4', '4', '7', '3', '3', '@'],
    ['2', '@', '4', '7', '3', '3', '@'],
    ['2', '2', '4', '7', '5', '3', '5'],
    ['6', '2', '7', '7', '5', '5', '5'],
    ['6', '2', '1', '1', '8', '8', '8'],
    ['6', '6', '1', '@', '8', '8', '8'],
    ['6', '1', '1', '@', '@', '@', '@']],
  '8-26': [['4', '4', '4', '3', '3', '3', '@'],
    ['6', '@', '4', '7', '3', '3', '@'],
    ['6', '6', '4', '7', '7', '7', '7'],
    ['6', '1', '2', '2', '2', '5', '5'],
    ['6', '1', '1', '1', '2', '2', '5'],
    ['8', '8', '8', '1', '@', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '8-27': [['4', '4', '4', '5', '5', '5', '@'],
    ['6', '@', '4', '5', '2', '5', '@'],
    ['6', '6', '4', '1', '2', '7', '7'],
    ['6', '1', '1', '1', '2', '2', '7'],
    ['6', '1', '8', '8', '8', '2', '7'],
    ['3', '3', '8', '8', '8', '@', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '8-28': [['4', '4', '4', '7', '8', '8', '@'],
    ['3', '@', '4', '7', '8', '8', '@'],
    ['3', '3', '4', '7', '8', '8', '1'],
    ['3', '3', '7', '7', '1', '1', '1'],
    ['6', '6', '6', '6', '1', '2', '2'],
    ['5', '6', '5', '2', '2', '2', '@'],
    ['5', '5', '5', '@', '@', '@', '@']],
  '8-29': [['4', '4', '4', '8', '8', '2', '@'],
    ['6', '@', '4', '8', '8', '2', '@'],
    ['6', '6', '4', '8', '8', '2', '2'],
    ['6', '1', '7', '7', '7', '7', '2'],
    ['6', '1', '1', '1', '5', '7', '5'],
    ['3', '3', '3', '1', '5', '5', '5'],
    ['@', '3', '3', '@', '@', '@', '@']],
  '8-3': [['7', '7', '3', '3', '1', '1', '@'],
    ['7', '@', '3', '3', '2', '1', '@'],
    ['7', '6', '@', '3', '2', '1', '1'],
    ['7', '6', '6', '2', '2', '8', '8'],
    ['4', '6', '5', '2', '5', '8', '8'],
    ['4', '6', '5', '5', '5', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '8-30': [['4', '4', '4', '3', '1', '1', '@'],
    ['6', '@', '4', '3', '3', '1', '@'],
    ['6', '6', '4', '3', '3', '1', '1'],
    ['6', '7', '7', '7', '7', '8', '8'],
    ['6', '2', '2', '2', '7', '8', '8'],
    ['5', '5', '5', '2', '2', '8', '8'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '8-31': [['4', '4', '4', '8', '8', '2', '@'],
    ['6', '@', '4', '8', '8', '2', '@'],
    ['6', '6', '4', '8', '8', '2', '2'],
    ['6', '1', '7', '7', '7', '7', '2'],
    ['6', '1', '1', '1', '5', '7', '5'],
    ['3', '3', '3', '1', '5', '5', '5'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '8-4': [['4', '4', '4', '3', '3', '2', '@'],
    ['6', '@', '4', '3', '3', '2', '@'],
    ['6', '6', '4', '@', '3', '2', '2'],
    ['6', '1', '7', '7', '7', '7', '2'],
    ['6', '1', '1', '1', '5', '7', '5'],
    ['8', '8', '8', '1', '5', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '8-5': [['4', '4', '4', '3', '3', '2', '@'],
    ['6', '@', '4', '3', '3', '2', '@'],
    ['6', '6', '4', '3', '@', '2', '2'],
    ['6', '1', '7', '7', '7', '7', '2'],
    ['6', '1', '1', '1', '5', '7', '5'],
    ['8', '8', '8', '1', '5', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '8-6': [['4', '4', '4', '5', '5', '5', '@'],
    ['6', '@', '4', '5', '2', '5', '@'],
    ['6', '6', '4', '1', '2', '@', '7'],
    ['6', '1', '1', '1', '2', '2', '7'],
    ['6', '1', '8', '8', '8', '2', '7'],
    ['3', '3', '8', '8', '8', '7', '7'],
    ['3', '3', '3', '@', '@', '@', '@']],
  '8-7': [['4', '4', '4', '3', '3', '3', '@'],
    ['2', '@', '4', '3', '3', '1', '@'],
    ['2', '2', '4', '1', '1', '1', '@'],
    ['7', '2', '5', '1', '5', '8', '8'],
    ['7', '2', '5', '5', '5', '8', '8'],
    ['7', '6', '6', '6', '6', '8', '8'],
    ['7', '7', '6', '@', '@', '@', '@']],
  '8-8': [['6', '6', '6', '6', '1', '1', '@'],
    ['2', '@', '6', '8', '8', '1', '@'],
    ['2', '2', '7', '8', '8', '1', '1'],
    ['@', '2', '7', '8', '8', '5', '5'],
    ['4', '2', '7', '3', '3', '3', '5'],
    ['4', '7', '7', '3', '3', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '8-9': [['6', '6', '6', '6', '3', '3', '@'],
    ['7', '@', '6', '3', '3', '3', '@'],
    ['7', '7', '7', '7', '2', '2', '2'],
    ['5', '@', '5', '2', '2', '1', '4'],
    ['5', '5', '5', '1', '1', '1', '4'],
    ['8', '8', '8', '1', '4', '4', '4'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '9-1': [['2', '4', '4', '4', '8', '8', '@'],
    ['2', '2', '@', '4', '8', '8', '@'],
    ['@', '2', '1', '4', '8', '8', '3'],
    ['6', '2', '1', '1', '1', '3', '3'],
    ['6', '5', '5', '7', '1', '3', '3'],
    ['6', '6', '5', '7', '7', '7', '7'],
    ['6', '5', '5', '@', '@', '@', '@']],
  '9-10': [['1', '1', '6', '6', '6', '6', '@'],
    ['2', '1', '@', '5', '6', '5', '@'],
    ['2', '1', '1', '5', '5', '5', '7'],
    ['2', '2', '@', '7', '7', '7', '7'],
    ['4', '2', '3', '3', '8', '8', '8'],
    ['4', '3', '3', '3', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-11': [['3', '3', '6', '6', '6', '6', '@'],
    ['3', '3', '@', '6', '2', '2', '@'],
    ['1', '3', '2', '2', '2', '7', '7'],
    ['1', '1', '1', '@', '8', '8', '7'],
    ['4', '5', '1', '5', '8', '8', '7'],
    ['4', '5', '5', '5', '8', '8', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-12': [['6', '5', '5', '5', '1', '1', '@'],
    ['6', '5', '@', '5', '2', '1', '@'],
    ['6', '6', '3', '2', '2', '1', '1'],
    ['6', '3', '3', '2', '@', '8', '8'],
    ['4', '3', '3', '2', '7', '8', '8'],
    ['4', '7', '7', '7', '7', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-13': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '@', '3', '3', '7', '@'],
    ['4', '1', '1', '3', '3', '5', '5'],
    ['4', '4', '4', '2', '3', '@', '5'],
    ['8', '8', '2', '2', '6', '5', '5'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '9-14': [['1', '1', '7', '7', '7', '7', '@'],
    ['4', '1', '@', '3', '3', '7', '@'],
    ['4', '1', '1', '3', '3', '5', '5'],
    ['4', '4', '4', '2', '3', '5', '@'],
    ['8', '8', '2', '2', '6', '5', '5'],
    ['8', '8', '2', '6', '6', '6', '6'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '9-15': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '7'],
    ['4', '4', '4', '7', '7', '7', '7'],
    ['@', '2', '2', '2', '3', '3', '3'],
    ['8', '8', '8', '2', '2', '3', '3'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '9-16': [['7', '7', '3', '3', '3', '2', '@'],
    ['7', '1', '@', '3', '3', '2', '@'],
    ['7', '1', '1', '1', '2', '2', '6'],
    ['7', '5', '5', '1', '2', '6', '6'],
    ['4', '@', '5', '8', '8', '8', '6'],
    ['4', '5', '5', '8', '8', '8', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-17': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '7'],
    ['4', '4', '4', '2', '3', '3', '7'],
    ['8', '8', '@', '2', '3', '3', '7'],
    ['8', '8', '2', '2', '3', '7', '7'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '9-18': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '7'],
    ['4', '4', '4', '7', '7', '7', '7'],
    ['3', '3', '3', '@', '8', '8', '8'],
    ['3', '3', '2', '2', '8', '8', '8'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '9-19': [['3', '3', '5', '5', '7', '7', '@'],
    ['3', '3', '@', '5', '7', '6', '@'],
    ['1', '3', '5', '5', '7', '6', '6'],
    ['1', '1', '1', '2', '7', '6', '4'],
    ['8', '8', '1', '2', '@', '6', '4'],
    ['8', '8', '2', '2', '4', '4', '4'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '9-2': [['3', '3', '5', '5', '1', '1', '@'],
    ['3', '3', '@', '5', '4', '1', '@'],
    ['3', '@', '5', '5', '4', '1', '1'],
    ['6', '7', '4', '4', '4', '8', '8'],
    ['6', '7', '7', '7', '7', '8', '8'],
    ['6', '6', '2', '2', '2', '8', '8'],
    ['6', '2', '2', '@', '@', '@', '@']],
  '9-20': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '6', '3', '3', '@'],
    ['4', '1', '1', '2', '3', '3', '3'],
    ['4', '4', '4', '2', '2', '5', '5'],
    ['7', '7', '7', '7', '2', '@', '5'],
    ['8', '8', '8', '7', '2', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '9-21': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '6', '3', '3', '@'],
    ['4', '1', '1', '2', '3', '3', '3'],
    ['4', '4', '4', '2', '2', '5', '5'],
    ['7', '7', '7', '7', '2', '5', '@'],
    ['8', '8', '8', '7', '2', '5', '5'],
    ['8', '8', '8', '@', '@', '@', '@']],
  '9-22': [['1', '1', '7', '7', '3', '3', '@'],
    ['4', '1', '@', '7', '3', '3', '@'],
    ['4', '1', '1', '7', '5', '3', '5'],
    ['4', '4', '4', '7', '5', '5', '5'],
    ['6', '6', '6', '6', '8', '8', '8'],
    ['@', '6', '2', '2', '8', '8', '8'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '9-23': [['1', '1', '6', '6', '6', '6', '@'],
    ['2', '1', '@', '5', '6', '5', '@'],
    ['2', '1', '1', '5', '5', '5', '7'],
    ['2', '2', '3', '7', '7', '7', '7'],
    ['4', '2', '3', '3', '8', '8', '8'],
    ['4', '@', '3', '3', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-24': [['3', '3', '7', '7', '7', '7', '@'],
    ['3', '3', '@', '1', '1', '7', '@'],
    ['2', '3', '8', '8', '1', '5', '5'],
    ['2', '2', '8', '8', '1', '1', '5'],
    ['4', '2', '8', '8', '6', '5', '5'],
    ['4', '2', '@', '6', '6', '6', '6'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-25': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '7'],
    ['4', '4', '4', '2', '3', '3', '7'],
    ['8', '8', '2', '2', '3', '3', '7'],
    ['8', '8', '2', '@', '3', '7', '7'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '9-26': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '3', '3', '8', '8', '8', '7'],
    ['3', '3', '2', '2', '@', '7', '7'],
    ['2', '2', '2', '@', '@', '@', '@']],
  '9-27': [['6', '7', '7', '7', '7', '2', '@'],
    ['6', '7', '@', '1', '1', '2', '@'],
    ['6', '6', '3', '3', '1', '2', '2'],
    ['6', '3', '3', '3', '1', '1', '2'],
    ['4', '8', '8', '8', '5', '5', '5'],
    ['4', '8', '8', '8', '5', '@', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-28': [['3', '3', '7', '7', '7', '7', '@'],
    ['3', '3', '@', '1', '1', '7', '@'],
    ['2', '3', '8', '8', '1', '5', '5'],
    ['2', '2', '8', '8', '1', '1', '5'],
    ['4', '2', '8', '8', '6', '5', '5'],
    ['4', '2', '6', '6', '6', '6', '@'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-29': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '3', '3', '8', '8', '8', '7'],
    ['3', '3', '2', '2', '2', '7', '7'],
    ['@', '2', '2', '@', '@', '@', '@']],
  '9-3': [['6', '7', '7', '7', '7', '1', '@'],
    ['6', '7', '@', '1', '1', '1', '@'],
    ['6', '6', '@', '1', '2', '3', '3'],
    ['6', '8', '8', '2', '2', '3', '3'],
    ['4', '8', '8', '2', '5', '3', '5'],
    ['4', '8', '8', '2', '5', '5', '5'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-30': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '6', '3', '3', '@'],
    ['4', '1', '1', '2', '3', '3', '3'],
    ['4', '4', '4', '2', '2', '8', '8'],
    ['7', '7', '7', '7', '2', '8', '8'],
    ['5', '5', '5', '7', '2', '8', '8'],
    ['5', '@', '5', '@', '@', '@', '@']],
  '9-31': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '7'],
    ['4', '4', '4', '8', '8', '8', '7'],
    ['3', '2', '2', '8', '8', '8', '7'],
    ['3', '3', '2', '2', '2', '7', '7'],
    ['3', '3', '@', '@', '@', '@', '@']],
  '9-4': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '6', '5', '5', '@'],
    ['4', '1', '1', '@', '5', '7', '7'],
    ['4', '4', '4', '2', '5', '5', '7'],
    ['8', '8', '2', '2', '3', '3', '7'],
    ['8', '8', '2', '3', '3', '3', '7'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '9-5': [['6', '5', '5', '5', '3', '3', '@'],
    ['6', '5', '@', '5', '3', '3', '@'],
    ['6', '6', '2', '1', '@', '3', '7'],
    ['6', '2', '2', '1', '1', '1', '7'],
    ['4', '2', '8', '8', '8', '1', '7'],
    ['4', '2', '8', '8', '8', '7', '7'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-6': [['3', '3', '6', '6', '6', '6', '@'],
    ['3', '3', '@', '6', '2', '2', '@'],
    ['1', '3', '2', '2', '2', '@', '7'],
    ['1', '1', '1', '7', '7', '7', '7'],
    ['4', '5', '1', '5', '8', '8', '8'],
    ['4', '5', '5', '5', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-7': [['1', '1', '6', '6', '6', '6', '@'],
    ['4', '1', '@', '5', '6', '5', '@'],
    ['4', '1', '1', '5', '5', '5', '@'],
    ['4', '4', '4', '2', '3', '3', '3'],
    ['8', '8', '2', '2', '3', '3', '7'],
    ['8', '8', '2', '7', '7', '7', '7'],
    ['8', '8', '2', '@', '@', '@', '@']],
  '9-8': [['8', '8', '7', '7', '7', '7', '@'],
    ['8', '8', '@', '6', '1', '7', '@'],
    ['8', '8', '2', '6', '1', '1', '1'],
    ['@', '2', '2', '6', '6', '3', '1'],
    ['4', '2', '5', '6', '5', '3', '3'],
    ['4', '2', '5', '5', '5', '3', '3'],
    ['4', '4', '4', '@', '@', '@', '@']],
  '9-9': [['6', '7', '7', '7', '7', '2', '@'],
    ['6', '7', '@', '1', '1', '2', '@'],
    ['6', '6', '3', '3', '1', '2', '2'],
    ['6', '@', '3', '3', '1', '1', '2'],
    ['4', '5', '3', '5', '8', '8', '8'],
    ['4', '5', '5', '5', '8', '8', '8'],
    ['4', '4', '4', '@', '@', '@', '@']]
}
